import React from "react";

import "../../css/carousels.css";

function SlideSix({ size }) {
  return (
    <div style={size}>
      <svg
        id="Floor_6"
        data-name="Floor 6"
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        viewBox="0 0 1000 795"
        style={{ width: "100%", maxWidth: "1000px" }}
      >
        <rect class="sixCls-11" width="1000" height="795" />
        <g>
          <polygon
            class="sixCls-11"
            points="370.29 163.72 346.09 165.25 322.14 163.2 294.7 163.72 256.36 162.72 201.76 162.1 200.86 17.17 371.13 17.65 369.7 53.35 371.92 97.65 370.29 138.83 370.29 163.72"
          />
          <polyline
            class="sixCls-3"
            points="202.18 163.19 201.17 142.9 202.06 121.99 200.56 101.09 202.45 80.19 200.8 59.29 201.7 38.38 200.86 17.17 225.6 17.91 249.89 17.14 274.19 17.65 298.48 17.06 322.78 17.55 347.08 17.03 371.13 17.65"
          />
        </g>
        <polyline
          class="sixCls-11"
          points="540.59 692.83 538.01 678.29 540.61 664.02 540.1 649.76 541.56 635.49 539.76 621.22 542.33 606.95 539.72 563.76"
        />
        <polyline
          class="sixCls-4"
          points="693.92 790.39 701.63 790.25 716.49 789.8 731.36 790.45 746.03 789.71"
        />
        <g>
          <polygon
            class="sixCls-11"
            points="370.61 455.73 328.89 453.27 286.36 455.46 243.83 454.27 200.45 455.39 202.49 412.93 200.37 371.07 201.77 329.21 200.14 287.35 201.48 245.49 200.07 203.63 201.76 162.1 249.57 162.69 273.72 162.57 297.83 164.04 322 162.88 346.09 165.25 370.29 162.9 370.61 162.99 371.25 183.06 369.7 220.17 371.47 255.5 369.7 295.5 371.03 335.06 369.66 375.98 371.57 415.86 370.61 455.73"
          />
          <polyline
            class="sixCls-3"
            points="370.61 455.73 328.89 453.27 286.36 455.46 243.83 454.27 200.45 455.39 202.49 412.93 200.37 371.07 201.77 329.21 200.14 287.35 201.48 245.49 200.07 203.63 201.76 162.1 249.57 162.69 273.72 162.57 297.83 164.04 322 162.88 346.09 165.25 370.29 162.9 370.61 162.99"
          />
        </g>
        <g>
          <polygon
            class="sixCls-11"
            points="547.78 235.65 576.78 236.53 605.17 235.37 633.55 236.16 661.94 235.2 690.33 236.75 718.71 235.14 745.98 236.85 747.27 263.67 746.14 291.27 748.04 318.86 745.64 346.46 747.73 374.05 746.6 401.65 747.66 429.64 718.71 428.7 690.33 429.67 661.94 429.03 633.55 429.78 605.17 429.16 576.78 429.82 548.7 429.04 546.8 401.65 548.72 374.05 548.33 346.46 549.46 318.86 548.08 291.27 550.05 263.67 547.78 235.65 547.78 235.65"
          />
          <polygon
            class="sixCls-3"
            points="547.78 235.65 576.78 236.53 605.17 235.37 633.55 236.16 661.94 235.2 690.33 236.75 718.71 235.14 745.98 236.85 747.27 263.67 746.14 291.27 748.04 318.86 745.64 346.46 747.73 374.05 746.6 401.65 747.66 429.64 718.71 428.7 690.33 429.67 661.94 429.03 633.55 429.78 605.17 429.16 576.78 429.82 548.7 429.04 546.8 401.65 548.72 374.05 548.33 346.46 549.46 318.86 548.08 291.27 550.05 263.67 547.78 235.65 547.78 235.65"
          />
        </g>
        <line class="sixCls-5" x1="995" y1="162.57" x2="995" y2="211.49" />
        <g id="Jharokhe">
          <polygon
            class="sixCls-11"
            points="796 598.32 817.74 598.98 839.02 598.11 860.3 598.7 881.58 597.98 902.87 599.14 924.15 597.94 944.6 599.22 945.55 619.19 944.71 639.73 946.13 660.28 944.34 680.83 945.9 701.38 945.06 721.92 945.85 742.76 924.15 742.06 902.87 742.79 881.58 742.31 860.3 742.87 839.02 742.41 817.74 742.9 796.68 742.31 795.26 721.92 796.7 701.38 796.41 680.83 797.25 660.28 796.22 639.73 797.69 619.19 796 598.32 796 598.32"
          />
          <polygon
            class="sixCls-9"
            points="796 598.32 817.74 598.98 839.02 598.11 860.3 598.7 881.58 597.98 902.87 599.14 924.15 597.94 944.6 599.22 945.55 619.19 944.71 639.73 946.13 660.28 944.34 680.83 945.9 701.38 945.06 721.92 945.85 742.76 924.15 742.06 902.87 742.79 881.58 742.31 860.3 742.87 839.02 742.41 817.74 742.9 796.68 742.31 795.26 721.92 796.7 701.38 796.41 680.83 797.25 660.28 796.22 639.73 797.69 619.19 796 598.32 796 598.32"
          />
          <g>
            <path
              class="sixCls-10"
              d="M841.69,675.73c.28.13.9.32,1.69.32,1.75,0,2.45-1.01,2.45-2.31v-8.11h-1.15v8.08c0,.89-.35,1.28-1.23,1.28-.61,0-1.07-.15-1.39-.33l-.38,1.06h0Z"
            />
            <path
              class="sixCls-10"
              d="M851.92,667.79c-1.34,0-2.06.73-2.29,1.01h-.06v-4.01h-1.14v11.07h1.14v-5.66c.28-.69,1.02-1.4,2.12-1.4s1.6.76,1.6,1.75v5.31h1.14v-5.49c0-1.62-.98-2.58-2.51-2.58h0Z"
            />
            <path
              class="sixCls-10"
              d="M860.9,674.01c-.36.54-1.08,1.08-1.98,1.08s-1.43-.57-1.43-1.27c0-1.2,1.5-1.66,3.41-1.59v1.78h0ZM859.26,667.81c-1.65,0-2.39.92-2.67,1.3l.83.66c.23-.38.74-.96,1.81-.96s1.68.38,1.68,1.68v.86c-2.82-.04-4.54.82-4.54,2.57,0,1.08.82,2.12,2.29,2.12,1.34,0,1.98-.63,2.36-1.07h.06c.19.54.66.96,1.44.96.15,0,.31-.03.41-.09v-.83h-.2c-.55,0-.77-.48-.77-1.2v-3.59c0-1.66-1.01-2.41-2.7-2.41h0Z"
            />
            <path
              class="sixCls-10"
              d="M868.72,667.86c-.18-.04-.44-.07-.8-.07-.92,0-1.65.44-2,1.01h-.06l-.25-.88h-.86v7.94h1.12v-5.91c.38-.71,1.18-1.02,1.96-1.02.29,0,.6.03.89.12v-1.18h0Z"
            />
            <path
              class="sixCls-10"
              d="M870.77,671.82c0-2.06.57-3.06,2.07-3.06s2.17,1.04,2.17,3.17-.56,3.08-2.09,3.08-2.16-1.05-2.16-3.18h0ZM872.84,675.99c2.41,0,3.34-1.71,3.34-4.16s-.83-4.06-3.25-4.06-3.33,1.68-3.33,4.13.83,4.09,3.24,4.09h0Z"
            />
            <path
              class="sixCls-10"
              d="M879.32,664.79h-1.14v11.07h1.14v-11.07h0ZM879.53,671.79l2.99,4.07h1.45l-3.11-4.1v-.06l2.93-3.78h-1.42l-2.85,3.81v.06h0Z"
            />
            <path
              class="sixCls-10"
              d="M888.97,667.79c-1.34,0-2.06.73-2.29,1.01h-.06v-4.01h-1.14v11.07h1.14v-5.66c.28-.69,1.02-1.4,2.12-1.4s1.6.76,1.6,1.75v5.31h1.14v-5.49c0-1.62-.98-2.58-2.51-2.58h0Z"
            />
            <path
              class="sixCls-10"
              d="M898.91,674.37c-.34.29-1.05.6-1.84.6-1.59,0-2.41-.74-2.51-2.7h5.05c.06-.51.09-.98.09-1.37,0-1.88-1.01-3.11-2.89-3.11-1.77,0-3.37,1.18-3.37,4.06s1.23,4.11,3.49,4.11c1.14,0,1.97-.32,2.49-.71l-.51-.88h0ZM896.71,668.77c1.28,0,1.87.76,1.87,2.12,0,.1,0,.28-.01.45h-3.98c.1-1.91,1.09-2.57,2.13-2.57h0Z"
            />
          </g>
        </g>
        <g id="Backstage">
          <polygon
            class="sixCls-11"
            points="461.69 692.89 461.86 789.85 290.91 789.85 267.4 791.96 261.12 789.85 250.49 789.85 251.25 757.7 249.92 725.48 251.69 693.04 250.25 663.48 251.25 628.04 249.37 594.48 250.49 563.15 539.08 563.15 541.13 586.61 540 649.92 537.67 678.48 539.37 692.89 461.69 692.89"
          />
          <path
            class="sixCls-2"
            d="M460.99,691.19l79.34.22-2.32-13.12,2.6-14.27-.51-14.27,1.45-14.27-1.8-14.27,2.57-14.27-2.6-43.19-17.42-.61-64.3-1.58-41.69,1.75-41.88-2.26-41.64,1.64-41.83-1-41.33,1-1.98,32.17,3.14,32.43-1.65,32.43,1.89,32.43-2.34,32.43,2.18,32.43-1.71,32.48,7.13-.77,6.92,2.22,14.1-.09,14.19-1.08,29.35-1.11,20.28,1.35,20.13-1.49,20.29,1.02,20.12-1.23,20.31,1.99,20.11-2.07,20.14,1.08-1.28-98.13Z"
          />
          <path
            class="sixCls-3"
            d="M462.92,789.72l-21.11-1.02-20.03,2.07-20.23-1.99-20.04,1.23-20.21-1.02-20.06,1.49-20.2-1.35-29.24,1.11-14.13,1.08-14.05.09-6.89-2.22-7.1.77,1.7-32.48-2.17-32.43,2.33-32.43-1.89-32.43,1.65-32.43-3.13-32.43,1.97-32.17,41.16-1,41.66,1,41.48-1.64,41.72,2.26,41.52-1.75,64.08.67M539.47,693.28l-2.17-14.51,2.59-14.27-.51-14.27,1.45-14.27-1.8-14.27,2.56-14.27-2.59-43.19"
          />
          <g>
            <g>
              <path
                class="sixCls-10"
                d="M364.8,691.37v-.06c.82-.2,1.39-1.06,1.39-2.31,0-1.93-1.33-2.61-2.9-2.61h-3.12v10.23h3.11c2.44,0,3.43-1.23,3.43-2.89,0-1.47-.83-2.23-1.9-2.36h0ZM365.03,689.12c0,1.28-.61,1.84-1.91,1.84h-1.82v-3.54h1.77c1.21,0,1.97.48,1.97,1.71h0ZM363.36,695.6h-2.06v-3.62h2c1.2,0,2.22.38,2.22,1.82,0,1.25-.67,1.79-2.16,1.79h0Z"
              />
              <path
                class="sixCls-10"
                d="M372.91,694.77c-.36.54-1.08,1.08-1.98,1.08s-1.43-.57-1.43-1.27c0-1.2,1.5-1.66,3.41-1.59v1.78h0ZM371.26,688.57c-1.65,0-2.39.92-2.67,1.3l.83.66c.23-.38.74-.96,1.81-.96s1.68.38,1.68,1.68v.86c-2.82-.04-4.54.82-4.54,2.57,0,1.08.82,2.12,2.29,2.12,1.34,0,1.98-.63,2.36-1.07h.06c.19.54.66.96,1.44.96.15,0,.31-.03.41-.09v-.83h-.2c-.55,0-.77-.48-.77-1.2v-3.59c0-1.66-1.01-2.41-2.7-2.41h0Z"
              />
              <path
                class="sixCls-10"
                d="M376.34,692.77c0,2.86,1.27,3.98,3.21,3.98,1.36,0,2.03-.48,2.35-.85l-.7-.79c-.32.36-.82.63-1.55.63-1.33,0-2.14-.86-2.14-3.12s.86-3.06,2.14-3.06c.77,0,1.24.32,1.56.66l.76-.83c-.29-.34-.99-.83-2.26-.83-1.94,0-3.37,1.3-3.37,4.22h0Z"
              />
              <path
                class="sixCls-10"
                d="M384.79,685.55h-1.14v11.07h1.14v-11.07h0ZM385.01,692.55l2.99,4.07h1.44l-3.11-4.1v-.06l2.93-3.78h-1.42l-2.85,3.81v.06h0Z"
              />
              <path
                class="sixCls-10"
                d="M394.7,694.52c0,.67-.54,1.25-1.65,1.25-.92,0-1.68-.38-2.16-.88l-.7.85c.5.51,1.49,1.01,2.8,1.01,1.91,0,2.83-1.17,2.83-2.26,0-2.7-4.01-1.98-4.01-3.76,0-.64.48-1.18,1.56-1.18.61,0,1.25.26,1.62.64l.73-.79c-.48-.51-1.37-.85-2.32-.85-1.74,0-2.71,1.06-2.71,2.2,0,2.68,4.01,1.97,4.01,3.76h0Z"
              />
              <path
                class="sixCls-10"
                d="M400.15,696.69c.95,0,1.47-.19,1.78-.36l-.32-.9c-.2.13-.57.28-1.21.28-.7,0-1.15-.36-1.15-1.25v-4.84h2.19v-.92h-2.19v-2.09h-.77l-.35,2.06-1.18.22v.73h1.18v4.9c0,1.5.71,2.19,2.03,2.19h0Z"
              />
              <path
                class="sixCls-10"
                d="M407.53,694.77c-.36.54-1.08,1.08-1.98,1.08s-1.43-.57-1.43-1.27c0-1.2,1.5-1.66,3.41-1.59v1.78h0ZM405.88,688.57c-1.65,0-2.39.92-2.67,1.3l.83.66c.23-.38.74-.96,1.81-.96s1.68.38,1.68,1.68v.86c-2.82-.04-4.54.82-4.54,2.57,0,1.08.82,2.12,2.29,2.12,1.34,0,1.98-.63,2.36-1.07h.06c.19.54.66.96,1.44.96.15,0,.31-.03.41-.09v-.83h-.2c-.55,0-.77-.48-.77-1.2v-3.59c0-1.66-1.01-2.41-2.7-2.41h0Z"
              />
              <path
                class="sixCls-10"
                d="M417.09,689.02c-.48-.23-1.25-.41-2.26-.41-2.63,0-3.87,1.71-3.87,4.25,0,2.7,1.39,3.72,3.02,3.72,1.02,0,1.69-.41,1.94-.63h.06v.73c0,1.42-.58,2.11-2.03,2.11-1.07,0-1.69-.35-2.09-.74l-.66.9c.32.32,1.11.85,2.61.85,1.98,0,3.27-1.04,3.27-3.12v-7.66h0ZM415.97,689.82v4.99c-.38.5-1.05.77-1.68.77-1.12,0-2.17-.6-2.17-2.87,0-2.1,1.02-3.11,2.55-3.11.51,0,.96.09,1.3.22h0Z"
              />
              <path
                class="sixCls-10"
                d="M424.56,695.13c-.34.29-1.05.6-1.84.6-1.59,0-2.41-.74-2.51-2.7h5.05c.06-.51.09-.98.09-1.37,0-1.88-1.01-3.11-2.89-3.11-1.77,0-3.37,1.18-3.37,4.06s1.22,4.11,3.49,4.11c1.14,0,1.97-.32,2.49-.71l-.51-.87h0ZM422.36,689.53c1.28,0,1.87.76,1.87,2.12,0,.1,0,.28-.01.45h-3.98c.1-1.91,1.09-2.57,2.13-2.57h0Z"
              />
            </g>
            <path
              class="sixCls-14"
              d="M395.48,672.4c-3.86.01-7.72.04-11.57.08-3.15.03-6.31.06-9.46.1-1.09.01-2.19.03-3.28.03.4-.21.84-.43,1.34-.68,1.27-.63,2.55-1.2,3.8-1.69,1.5-.58,3.13-1.13,4.84-1.61.67-.19,1.84-.51,3.58-.9,1.45-.33,3.15-.7,5.04-.87.87-.07,1.89-.15,2.81-.15.1,0,.19,0,.29,0h.43c.84,0,1.82,0,2.73.06,2.15.13,4.12.53,6.02.9.17.04.35.07.54.11,1.09.21,2.45.48,4.46,1.17l.13.05c1.38.48,3.28,1.14,5.28,2.22.98.49,1.72.95,2.29,1.33-2.56-.08-5.13-.11-7.69-.13-3.86-.03-7.73-.03-11.59-.02h0ZM417.2,673.14c-.11-.66-1.55-2.15-3.75-3.51-.59-.37-1.53-.86-2.43-1.28-1.04-.48-2.02-.87-2.35-1l-.09-.04c-1.87-.77-3.98-1.31-5.98-1.79-1.85-.45-3.94-.78-6.6-1.03l-.34-.03c-.93-.09-1.74-.16-2.67-.19.02-.31.04-.66.06-1.01.03-.48.06-.98.08-1.31v-.03s.07,0,.07,0h.05c.09-.02.18-.05.27-.07l.12-.03c.28-.08.52-.16.74-.26.52-.22.99-.51,1.39-.86.44-.37.82-.84,1.09-1.33.28-.5.45-1.08.51-1.69.05-.57,0-1.13-.17-1.68-.16-.54-.43-1.04-.77-1.45-.06-.08-.13-.15-.2-.22l-.07-.08c-.07-.07-.15-.13-.23-.2l-.08-.06c-.16-.12-.38-.27-.61-.39-.39-.2-.8-.33-1.17-.39-.14-.03-.26-.04-.37-.05-.04,0-.08,0-.15-.01-.13,0-.24,0-.36,0-.02,0-.04,0-.06,0-.87.03-1.73.28-2.57.74-.17.09-.33.2-.49.31-.14.1-.28.2-.43.33-.27.22-.51.46-.7.7-.37.45-.62.95-.69,1.38-.12.7.23.9.34.95.07.03.14.04.21.04.22,0,.43-.13.63-.26l.16-.1c.2-.14.43-.29.71-.45,1.08-.6,2.09-.94,2.92-.97h.08c.78,0,1.3.33,1.55.98.18.47.17,1.08-.04,1.55-.22.53-.7,1.02-1.31,1.35-.13.07-.27.14-.44.21-.03.01-.07.03-.11.04-.04.02-.09.03-.14.05l-.1.03s-.04.01-.07.02h-.05c-.06.03-.11.04-.17.06l-.1.03s-.04.01-.07.02c-.06.02-.14.04-.2.07-.09.04-.18.09-.24.14-.18.13-.32.33-.38.53-.09.27-.08.58-.07.85,0,.06,0,.12,0,.2.01.29.03.71.05,1.14.02.42.03.85.05,1.21-.5.02-1.01.05-1.47.08l-.4.02c-2,.12-3.79.46-5.42.8-1.44.3-2.77.62-3.74.9-1.82.51-3.53,1.14-5.1,1.87-1.39.65-2.73,1.41-3.88,2.2-1.39.96-2.47,1.94-2.88,2.58-.44.31-.32,1.18.37,1.18,1.53.02,3.05-.02,4.58-.03,3.02-.03,6.03-.07,9.05-.1,3.81-.04,7.62-.07,11.42-.08,3.9-.02,7.8-.02,11.7,0,3.29.02,6.59.06,9.88.17.34.01.67.02,1.01.04.38.01.59-.25.62-.54.02-.06.02-.14,0-.23h0Z"
            />
          </g>
        </g>
        <g id="Signage_list" data-name="Signage list">
          <path
            class="sixCls-10"
            d="M9.69,36.14c0,1.12-.91,2.02-2.02,2.02s-2.02-.91-2.02-2.02.91-2.02,2.02-2.02,2.02.91,2.02,2.02h0Z"
          />
          <g>
            <path
              class="sixCls-10"
              d="M3.42,46.03c-.49,0-.89-.39-.9-.89l-.05-3.46c0-.26.11-.51.3-.68l2.37-2.13c.19-.17.44-.25.7-.23l2.09.22,1.63-.21c.36-.05.72.13.9.45l1.74,3.08,1.85-1.13c.42-.26.98-.13,1.24.3.26.42.13.98-.3,1.24l-2.65,1.62c-.21.13-.46.17-.7.1-.24-.06-.44-.22-.56-.43l-1.9-3.37-1.13.14c-.07,0-.14,0-.21,0l-1.8-.19-1.77,1.59.05,3.05c0,.5-.39.91-.89.91h-.01Z"
            />
            <path
              class="sixCls-10"
              d="M5.09,57.25c-.05,0-.1,0-.16-.01-.56-.09-.95-.61-.86-1.18l1.54-10.07c.05-.3.22-.57.48-.72.26-.16.58-.19.87-.1l6.1,2.04c.47.16.76.62.7,1.11l-.54,4.09c-.07.56-.59.96-1.16.89-.56-.07-.96-.59-.89-1.16l.43-3.25-4.13-1.38-1.35,8.86c-.08.51-.52.88-1.02.88h0Z"
            />
            <path
              class="sixCls-10"
              d="M9.78,47.71h-4.2c-.1,0-.18-.08-.18-.18v-8.69c0-.1.08-.18.18-.18h4.2c.1,0,.19.08.19.18v8.69c0,.1-.08.18-.19.18h0Z"
            />
            <polygon
              class="sixCls-10"
              points="23.06 49.78 15.72 49.78 16.71 53.35 9.05 53.35 10.04 56.91 1.97 56.91 1.97 58.93 13.19 58.93 12.2 55.36 19.86 55.36 18.87 51.8 23.63 51.8 23.06 49.78 23.06 49.78"
            />
            <path
              class="sixCls-10"
              d="M50.99,46.32c-1.47,0-2.45-.6-3.13-1.16l-.82,1.12c.7.63,1.98,1.3,3.83,1.3,2.63,0,4.1-1.54,4.1-3.4,0-3.78-5.85-3.19-5.85-6.02,0-1.12.86-1.93,2.29-1.93,1.03,0,1.79.35,2.4.84l.86-1.09c-.7-.58-1.79-1.03-3.17-1.03-2.21,0-3.8,1.44-3.8,3.29,0,3.87,5.85,3.24,5.85,6.02,0,1.14-.89,2.05-2.56,2.05h0Z"
            />
            <path
              class="sixCls-10"
              d="M60.01,47.49c1.14,0,1.77-.23,2.14-.44l-.38-1.09c-.25.16-.68.33-1.45.33-.84,0-1.38-.44-1.38-1.51v-5.81h2.63v-1.1h-2.63v-2.5h-.93l-.42,2.47-1.42.26v.88h1.42v5.88c0,1.8.86,2.63,2.43,2.63h0Z"
            />
            <path
              class="sixCls-10"
              d="M68.87,45.18c-.44.65-1.3,1.3-2.38,1.3s-1.72-.68-1.72-1.52c0-1.44,1.8-2,4.1-1.91v2.14h0ZM66.89,37.74c-1.98,0-2.87,1.1-3.2,1.56l1,.79c.28-.45.89-1.16,2.17-1.16s2.01.46,2.01,2.01v1.03c-3.38-.05-5.44.98-5.44,3.08,0,1.3.98,2.54,2.75,2.54,1.61,0,2.38-.75,2.84-1.28h.07c.23.65.79,1.16,1.73,1.16.18,0,.37-.04.49-.11v-1h-.24c-.67,0-.93-.58-.93-1.44v-4.31c0-2-1.21-2.89-3.24-2.89h0Z"
            />
            <path
              class="sixCls-10"
              d="M73.95,47.41h1.37v-9.52h-1.37v9.52h0ZM73.56,35.12c0,.56.44.98.98.98.58,0,1.02-.42,1.02-.98s-.44-1-1.02-1c-.54,0-.98.42-.98,1h0Z"
            />
            <path
              class="sixCls-10"
              d="M83.31,37.81c-.21-.05-.53-.09-.96-.09-1.1,0-1.98.53-2.4,1.21h-.07l-.3-1.05h-1.03v9.52h1.35v-7.09c.45-.86,1.42-1.22,2.35-1.22.35,0,.72.03,1.07.14v-1.42h0Z"
            />
            <path
              class="sixCls-10"
              d="M89.21,44.89c0,.81-.65,1.51-1.98,1.51-1.1,0-2.01-.45-2.59-1.05l-.84,1.02c.6.61,1.79,1.21,3.36,1.21,2.29,0,3.4-1.4,3.4-2.71,0-3.24-4.81-2.38-4.81-4.52,0-.77.58-1.42,1.87-1.42.74,0,1.51.32,1.94.77l.88-.95c-.58-.61-1.65-1.01-2.78-1.01-2.08,0-3.26,1.28-3.26,2.64,0,3.22,4.81,2.36,4.81,4.52h0Z"
            />
          </g>
          <g>
            <path
              class="sixCls-10"
              d="M25.84,18.76c-.1-.1-.26-.1-.36,0l-.76.76v-2.88c0-.14-.11-.25-.26-.25s-.25.11-.25.25v2.88l-.76-.76c-.1-.1-.26-.1-.36,0-.1.1-.1.26,0,.36l1.16,1.16s.06.05.1.06c.03.01.07.02.11.02s.07,0,.11-.02c.04-.01.07-.03.1-.06l1.16-1.16c.1-.1.1-.26,0-.36h0Z"
            />
            <path
              class="sixCls-10"
              d="M25.84,12.87l-1.16-1.16s-.06-.05-.1-.06c-.03-.01-.07-.02-.11-.02s-.07,0-.11.02c-.04.01-.07.03-.1.06l-1.16,1.16c-.1.1-.1.26,0,.36.05.05.12.08.18.08s.13-.02.18-.08l.76-.75v2.87c0,.14.11.26.25.26s.26-.11.26-.26v-2.88l.76.76c.05.05.11.08.18.08s.13-.02.18-.08c.1-.1.1-.26,0-.36h0Z"
            />
            <path
              class="sixCls-10"
              d="M3.6,4.52c-.38,0-.7.31-.7.7v21.55c0,.38.31.7.7.7h16.2c.38,0,.7-.31.7-.7V5.22c0-.38-.31-.7-.7-.7H3.6ZM19.8,28.4H3.6c-.9,0-1.63-.73-1.63-1.63V5.22c0-.9.73-1.63,1.63-1.63h16.2c.9,0,1.63.73,1.63,1.63v21.55c0,.9-.73,1.63-1.63,1.63h0Z"
            />
            <path
              class="sixCls-10"
              d="M13.49,9.01c0,.99-.8,1.79-1.79,1.79s-1.79-.8-1.79-1.79.8-1.79,1.79-1.79,1.79.8,1.79,1.79h0Z"
            />
            <path
              class="sixCls-10"
              d="M13.87,11.29h-4.34c-.74,0-1.34.51-1.34,1.14v5.36c0,.34.32.61.72.61s.72-.27.72-.61v-5.28h.37v14.09c0,.34.32.61.72.61s.72-.27.72-.61v-7.76h.5v7.76c0,.34.32.61.72.61s.72-.27.72-.61v-8.55s0-5.54,0-5.54h.37v5.28c0,.34.32.61.72.61s.72-.27.72-.61v-5.37c0-.63-.6-1.14-1.34-1.14h0Z"
            />
            <polygon
              class="sixCls-10"
              points="47.22 4.76 47.22 17.03 53.89 17.03 53.89 15.79 48.62 15.79 48.62 4.76 47.22 4.76 47.22 4.76"
            />
            <path
              class="sixCls-10"
              d="M56.08,17.03h1.37V7.51h-1.37v9.52h0ZM55.7,4.74c0,.56.44.98.98.98.58,0,1.02-.42,1.02-.98s-.44-1-1.02-1c-.54,0-.98.42-.98,1h0Z"
            />
            <path
              class="sixCls-10"
              d="M65.5,3.8c-.37-.12-.81-.21-1.47-.21-1.86,0-2.71,1.01-2.71,2.49v1.44h-1.59v1.07h1.58v8.46h1.37v-8.46h2.49v-1.07h-2.47v-1.45c0-.86.35-1.28,1.26-1.28.54,0,.93.05,1.28.18l.28-1.16h0Z"
            />
            <path
              class="sixCls-10"
              d="M69.7,17.12c1.14,0,1.77-.23,2.14-.44l-.38-1.09c-.25.16-.68.33-1.45.33-.84,0-1.38-.44-1.38-1.51v-5.81h2.63v-1.1h-2.63v-2.5h-.93l-.42,2.47-1.42.26v.88h1.42v5.88c0,1.8.86,2.63,2.43,2.63h0Z"
            />
          </g>
          <g>
            <path
              class="sixCls-10"
              d="M12.8,77.53c-.23,0-.44.07-.61.18-.68.44-.52,1.5.24,1.79l.15.06c1.76.66,3.62,1,5.49,1h2.47c.47,0,.85-.38.85-.85v-1.51c0-.38-.31-.69-.69-.69l-7.92.03h0Z"
            />
            <path
              class="sixCls-10"
              d="M14.71,72.01c0,1.42-1.15,2.57-2.57,2.57s-2.58-1.15-2.58-2.57,1.15-2.58,2.58-2.58,2.57,1.15,2.57,2.58h0Z"
            />
            <path
              class="sixCls-10"
              d="M13.42,81.52l-3.52-2.37v-4.21c0-.23-.07-.44-.18-.62-.11-.23-.27-.44-.48-.6-.73-.57-1.78-.44-2.34.29l-4.58,5.88c-.06.08-.11.16-.16.25-.12.2-.19.43-.19.68v12.11c0,.73.59,1.31,1.31,1.31s1.31-.59,1.31-1.31v-10.66c.13-.09.26-.2.36-.34l2.66-3.41v1.23c0,.38.19.74.51.95l4.02,2.71c.2.13.42.2.64.2.37,0,.73-.18.95-.51.35-.53.22-1.24-.31-1.59h0Z"
            />
            <path
              class="sixCls-10"
              d="M19.91,77.77h-.7s-.06-.03-.06-.06v-.44s.03-.06.06-.06h.7s.06.03.06.06v.44s-.03.06-.06.06h0Z"
            />
            <path
              class="sixCls-10"
              d="M17.3,74.31h0c-.17-.07-.26-.26-.19-.43.07-.17.26-.26.43-.19.17.07.26.26.19.43-.05.13-.18.21-.31.21-.04,0-.08,0-.12-.02h0ZM16.23,74.56c-.14-.12-.16-.33-.04-.47.12-.14.33-.16.47-.04.14.12.16.33.04.47-.07.08-.16.12-.26.12-.08,0-.15-.03-.21-.08h0ZM18,74.92h0c-.12-.14-.09-.35.05-.47.14-.12.35-.09.47.05h0c.11.14.09.35-.05.47-.06.05-.13.07-.21.07-.1,0-.2-.04-.26-.12h0ZM15.63,75.51c-.16-.1-.21-.3-.11-.46.1-.16.31-.2.46-.11.16.1.2.31.11.46-.06.1-.17.16-.29.16-.06,0-.12-.02-.18-.05h0ZM18.59,75.8c-.09-.16-.04-.36.12-.46.16-.09.36-.04.46.12.09.16.04.36-.12.45-.05.03-.11.04-.17.04-.12,0-.23-.06-.29-.17h0ZM15.1,76.48c-.16-.09-.22-.29-.14-.45.09-.16.29-.22.45-.14.16.09.22.29.14.45-.06.11-.18.18-.3.18-.05,0-.11-.01-.16-.04h0ZM19.1,76.77h0c-.08-.16-.02-.37.15-.45.16-.08.36-.01.45.15.08.16.02.36-.15.45-.05.02-.1.04-.15.04-.12,0-.24-.07-.3-.19h0Z"
            />
            <path
              class="sixCls-10"
              d="M12.8,77.53c-.23,0-.44.07-.61.18-.68.44-.52,1.5.24,1.79l.15.06c1.76.66,3.62,1,5.49,1h2.47c.47,0,.85-.38.85-.85v-1.51c0-.38-.31-.69-.69-.69l-7.92.03h0Z"
            />
            <path
              class="sixCls-10"
              d="M14.71,72.01c0,1.42-1.15,2.57-2.57,2.57s-2.58-1.15-2.58-2.57,1.15-2.58,2.58-2.58,2.57,1.15,2.57,2.58h0Z"
            />
            <path
              class="sixCls-10"
              d="M13.42,81.52l-3.52-2.37v-4.21c0-.23-.07-.44-.18-.62-.11-.23-.27-.44-.48-.6-.73-.57-1.78-.44-2.34.29l-4.58,5.88c-.06.08-.11.16-.16.25-.12.2-.19.43-.19.68v12.11c0,.73.59,1.31,1.31,1.31s1.31-.59,1.31-1.31v-10.66c.13-.09.26-.2.36-.34l2.66-3.41v1.23c0,.38.19.74.51.95l4.02,2.71c.2.13.42.2.64.2.37,0,.73-.18.95-.51.35-.53.22-1.24-.31-1.59h0Z"
            />
            <path
              class="sixCls-10"
              d="M19.91,77.77h-.7s-.06-.03-.06-.06v-.44s.03-.06.06-.06h.7s.06.03.06.06v.44s-.03.06-.06.06h0Z"
            />
            <path
              class="sixCls-10"
              d="M17.3,74.31h0c-.17-.07-.26-.26-.19-.43.07-.17.26-.26.43-.19.17.07.26.26.19.43-.05.13-.18.21-.31.21-.04,0-.08,0-.12-.02h0ZM16.23,74.56c-.14-.12-.16-.33-.04-.47.12-.14.33-.16.47-.04.14.12.16.33.04.47-.07.08-.16.12-.26.12-.08,0-.15-.03-.21-.08h0ZM18,74.92h0c-.12-.14-.09-.35.05-.47.14-.12.35-.09.47.05h0c.11.14.09.35-.05.47-.06.05-.13.07-.21.07-.1,0-.2-.04-.26-.12h0ZM15.63,75.51c-.16-.1-.21-.3-.11-.46.1-.16.31-.2.46-.11.16.1.2.31.11.46-.06.1-.17.16-.29.16-.06,0-.12-.02-.18-.05h0ZM18.59,75.8c-.09-.16-.04-.36.12-.46.16-.09.36-.04.46.12.09.16.04.36-.12.45-.05.03-.11.04-.17.04-.12,0-.23-.06-.29-.17h0ZM15.1,76.48c-.16-.09-.22-.29-.14-.45.09-.16.29-.22.45-.14.16.09.22.29.14.45-.06.11-.18.18-.3.18-.05,0-.11-.01-.16-.04h0ZM19.1,76.77h0c-.08-.16-.02-.37.15-.45.16-.08.36-.01.45.15.08.16.02.36-.15.45-.05.02-.1.04-.15.04-.12,0-.24-.07-.3-.19h0Z"
            />
            <path
              class="sixCls-10"
              d="M47.22,77.88h3.2c3.76,0,5.38-2.26,5.38-6.25s-1.66-6.02-5.36-6.02h-3.22v12.27h0ZM48.62,66.85h1.7c2.61,0,4.04,1.28,4.04,4.94s-1.26,4.85-3.96,4.85h-1.79v-9.79h0Z"
            />
            <path
              class="sixCls-10"
              d="M63.08,68.29c-.21-.05-.53-.09-.96-.09-1.1,0-1.98.53-2.4,1.21h-.07l-.3-1.05h-1.03v9.52h1.35v-7.09c.45-.86,1.42-1.22,2.35-1.22.35,0,.72.03,1.07.14v-1.42h0Z"
            />
            <path
              class="sixCls-10"
              d="M65.1,77.88h1.37v-9.52h-1.37v9.52h0ZM64.71,65.59c0,.56.44.98.98.98.58,0,1.02-.42,1.02-.98s-.44-1-1.02-1c-.54,0-.98.42-.98,1h0Z"
            />
            <path
              class="sixCls-10"
              d="M76.9,71.32c-.05-2.12-1.19-3.15-3.1-3.15-1.49,0-2.45.86-2.71,1.19h-.07l-.28-1h-1.03v9.52h1.37v-6.81c.33-.93,1.24-1.7,2.42-1.7,1.33,0,2.05.81,2.05,2.26v6.25h1.37v-6.57h0Z"
            />
            <path
              class="sixCls-10"
              d="M81.12,64.59h-1.37v13.29h1.37v-13.29h0ZM81.38,73l3.59,4.88h1.73l-3.73-4.92v-.07l3.52-4.53h-1.7l-3.41,4.57v.07h0Z"
            />
            <path
              class="sixCls-10"
              d="M88.98,77.88h1.37v-9.52h-1.37v9.52h0ZM88.59,65.59c0,.56.44.98.98.98.58,0,1.02-.42,1.02-.98s-.44-1-1.02-1c-.54,0-.98.42-.98,1h0Z"
            />
            <path
              class="sixCls-10"
              d="M100.78,71.32c-.05-2.12-1.19-3.15-3.1-3.15-1.49,0-2.45.86-2.71,1.19h-.07l-.28-1h-1.03v9.52h1.37v-6.81c.33-.93,1.24-1.7,2.42-1.7,1.33,0,2.05.81,2.05,2.26v6.25h1.37v-6.57h0Z"
            />
            <path
              class="sixCls-10"
              d="M110.48,68.76c-.58-.28-1.51-.49-2.71-.49-3.15,0-4.64,2.05-4.64,5.09,0,3.24,1.66,4.46,3.62,4.46,1.22,0,2.03-.49,2.33-.75h.07v.88c0,1.7-.7,2.54-2.43,2.54-1.28,0-2.03-.42-2.5-.89l-.79,1.09c.39.38,1.33,1.01,3.13,1.01,2.38,0,3.92-1.24,3.92-3.75v-9.19h0ZM109.13,69.72v5.99c-.45.6-1.26.93-2.01.93-1.35,0-2.61-.72-2.61-3.45,0-2.52,1.23-3.73,3.06-3.73.61,0,1.16.11,1.56.26h0Z"
            />
            <path
              class="sixCls-10"
              d="M52.26,90.77l1.94,8.12h1.84l2.56-9.52h-1.31l-1.35,5.23c-.26,1-.51,2.05-.74,3.08h-.07c-.19-.96-.4-1.82-.61-2.7l-1.4-5.62h-1.75l-1.43,5.62c-.23.88-.42,1.77-.61,2.7h-.07c-.21-1.05-.45-2.05-.72-3.06l-1.33-5.25h-1.4l2.52,9.52h1.84l2.03-8.12h.07Z"
            />
            <path
              class="sixCls-10"
              d="M65.18,96.67c-.44.65-1.3,1.3-2.38,1.3s-1.72-.68-1.72-1.52c0-1.44,1.8-2,4.1-1.91v2.14h0ZM63.21,89.23c-1.98,0-2.87,1.1-3.2,1.56l1,.79c.28-.45.89-1.16,2.17-1.16s2.01.46,2.01,2.01v1.03c-3.38-.05-5.44.98-5.44,3.08,0,1.3.98,2.54,2.75,2.54,1.61,0,2.38-.75,2.84-1.28h.07c.23.65.79,1.16,1.73,1.16.18,0,.37-.04.49-.1v-1h-.24c-.67,0-.93-.58-.93-1.44v-4.31c0-2-1.21-2.89-3.24-2.89h0Z"
            />
            <path
              class="sixCls-10"
              d="M72.54,98.98c1.14,0,1.77-.23,2.14-.44l-.38-1.09c-.25.16-.68.33-1.45.33-.84,0-1.38-.44-1.38-1.51v-5.81h2.63v-1.1h-2.63v-2.5h-.93l-.42,2.47-1.42.26v.88h1.42v5.88c0,1.8.86,2.63,2.43,2.63h0Z"
            />
            <path
              class="sixCls-10"
              d="M82.54,97.11c-.4.35-1.26.72-2.21.72-1.91,0-2.89-.89-3.01-3.24h6.06c.07-.61.11-1.17.11-1.65,0-2.26-1.21-3.73-3.47-3.73-2.12,0-4.04,1.42-4.04,4.87s1.47,4.94,4.18,4.94c1.37,0,2.36-.39,2.99-.86l-.61-1.05h0ZM79.89,90.38c1.54,0,2.24.91,2.24,2.54,0,.12,0,.33-.02.54h-4.78c.12-2.29,1.31-3.08,2.56-3.08h0Z"
            />
            <path
              class="sixCls-10"
              d="M90.75,89.3c-.21-.05-.53-.09-.96-.09-1.1,0-1.98.53-2.4,1.21h-.07l-.3-1.05h-1.03v9.52h1.35v-7.09c.45-.86,1.42-1.23,2.35-1.23.35,0,.72.03,1.07.14v-1.42h0Z"
            />
          </g>
          <g>
            <path
              class="sixCls-16"
              d="M18.66,355.96v2.97c0,.28.38.42.69.38.4-.05.41-.27.41-.66v-1.07c0-.57.06-1.8-.13-2.21-.11-.22-.36-.51-.55-.62-.4-.23-1.56-.24-2.11-.24-.87,0-1.57.06-2.1.54-.23.21-.31.48-.35.9-.04.41-.05,2.39-.03,3,.02.42.55.42.78.33.17-.07.21-.15.21-.37v-2.8s.22.01.22.01c.02,2.5.04,5,.05,7.5,0,.28-.05.65.11.84.26.3.82.18,1.04-.05.09-.1.09-.21.09-.38l.04-3.73c0-.78-.06-.72.2-.69v4.32c.02.25-.02.52.14.65.15.12.42.13.63.06.51-.16.49-.6.48-1.05-.02-2.16-.02-3.81,0-5.91,0-.29,0-.57.01-.85,0-.1,0-.71.02-.81v-.04s.15,0,.15,0h0Z"
            />
            <path
              class="sixCls-16"
              d="M9.91,355.98c.25-.05.21.03.21.23.02,2.66.02,4.65,0,7.31,0,.54,0,.85.38,1.05.22.11.86.22.86-.36v-4.62s.21,0,.21,0c0,1.23.02,2.46.03,3.69,0,.27-.02.67.01.93.02.21.3.36.54.4.31.05.55-.06.65-.27.09-.18.05-.65.05-.88.02-2.46.04-4.92.05-7.37h.21s0,2.82,0,2.82c0,.46.54.43.74.36.15-.06.25-.13.25-.33.02-.63.01-2.51-.02-2.96-.03-.43-.11-.71-.34-.93-.46-.44-1.15-.55-1.99-.55-.58,0-1.82,0-2.24.25-.18.11-.45.42-.55.65-.13.29-.12.73-.12,1.07v1.66c0,.69-.11,1.13.4,1.2.17.03.32,0,.45-.08.18-.1.18-.21.18-.42,0-.63-.03-2.32.02-2.83,0,0,0-.01,0-.02h0Z"
            />
            <path
              class="sixCls-16"
              d="M23.5,365.01c.52,0,2.84.06,3.13-.13-.04-.21-1.1-1.23-1.34-1.47-.16-.15-.3-.31-.47-.47l-4.58.1c-.04.67-.03,1.4-.04,2.07-.01.69-.03,1.38-.04,2.07,0,.1-.02.44,0,.5.02.07,1.19,1.17,1.33,1.3.09.09.45.43.59.45.21-.3.1-2.43.14-2.96.08.05.33.31.41.4l1.99,1.98c.15.14.67.7.82.76l.7-.61c.11-.12.57-.56.68-.63-.04-.1-.33-.36-.42-.45l-2.89-2.92h0Z"
            />
            <path
              class="sixCls-16"
              d="M8.53,362.96c-.18-.03-3.93,0-4.22,0-.09,0-.2,0-.28,0-.12,0-.3.23-.43.36-.31.3-1.38,1.31-1.55,1.61.27.12,2.59.15,3.08.17-.03.07,0,.02-.05.08l-2.73,2.69c-.12.12-.28.26-.38.38.11.12.22.23.33.35.11.11.21.24.33.34l.66.69c.12-.07,3.24-3.25,3.36-3.3,0,.83-.08,2.41.12,3.13.21-.04,1.07-.94,1.23-1.11.05-.05.08-.09.13-.14.33-.35.41-.34.4-.62-.01-1.53.02-3.07,0-4.61h0Z"
            />
            <path
              class="sixCls-16"
              d="M22.28,347.96c-.01-.52-.05-2.55-.18-2.92-.32-.02-1.38,1.14-1.67,1.43-.36.37-.29.21-.29.74v4.13c.21.03,4.17.01,4.73,0,.12,0,.34-.27.47-.4.22-.21,1.21-1.19,1.28-1.39-.28-.17-2.61-.04-3.13-.1l3.3-3.34c-.16-.19-.79-.74-1-.98-.07-.08-.26-.28-.35-.33-.16.09-3.08,3.13-3.19,3.15h0Z"
            />
            <path
              class="sixCls-16"
              d="M6.57,347.95c-.09-.01-.34-.31-.41-.37l-1.18-1.18c-.26-.26-1.44-1.45-1.64-1.54-.24.1-1.18,1.05-1.29,1.3.17.37,2.96,2.95,3.06,3.22-.27.16-2.62.08-3.12.09l1.81,1.86c.09.05.39.02.51.02.27,0,4.07.02,4.22-.01v-4.21c0-.52.1-.41-.28-.77l-1.59-1.55-.1,3.15h0Z"
            />
            <path
              class="sixCls-16"
              d="M16.91,352.06c-.37.05-.53.16-.67.39-.35.56-.21,1.96,1.19,1.66.32-.07.51-.21.64-.42.28-.45.28-.73-.03-1.19-.1-.15-.14-.17-.28-.26-.23-.15-.53-.22-.85-.18h0Z"
            />
            <path
              class="sixCls-16"
              d="M11.4,352.06c-1.35.18-1.31,2.25.31,2.06.66-.08,1.04-.58.91-1.18-.11-.51-.59-.97-1.22-.88h0Z"
            />
            <path
              class="sixCls-16"
              d="M14.36,350.2c.63,0,1.15.51,1.15,1.15s-.51,1.15-1.15,1.15-1.15-.51-1.15-1.15.51-1.15,1.15-1.15h0Z"
            />
            <polygon
              class="sixCls-10"
              points="54.58 351.01 54.58 349.77 49.22 349.77 49.22 345.41 53.72 345.41 53.72 344.17 49.22 344.17 49.22 339.98 54.33 339.98 54.33 338.74 47.82 338.74 47.82 351.01 54.58 351.01 54.58 351.01"
            />
            <path
              class="sixCls-10"
              d="M63.31,342.8h-.07c-.35-.86-1.1-1.51-2.52-1.51-1.49,0-2.21.81-2.47,1.21h-.07l-.28-1.02h-1.05v9.52h1.37v-6.81c.19-.82.96-1.7,2.15-1.7s1.89.82,1.89,2.33v6.18h1.37v-6.92c.25-.77,1-1.59,2.19-1.59s1.87.75,1.87,2.22v6.29h1.35v-6.57c0-2.08-1.05-3.15-2.94-3.15-1.49,0-2.42.74-2.78,1.51h0Z"
            />
            <path
              class="sixCls-10"
              d="M77.95,349.22c-.4.35-1.26.72-2.21.72-1.91,0-2.89-.89-3.01-3.24h6.06c.07-.61.11-1.17.11-1.65,0-2.26-1.21-3.73-3.47-3.73-2.12,0-4.04,1.42-4.04,4.87s1.47,4.94,4.18,4.94c1.37,0,2.36-.39,2.99-.86l-.61-1.05h0ZM75.31,342.5c1.54,0,2.24.91,2.24,2.54,0,.12,0,.33-.02.54h-4.78c.12-2.29,1.31-3.08,2.56-3.08h0Z"
            />
            <path
              class="sixCls-10"
              d="M86.16,341.42c-.21-.05-.53-.09-.96-.09-1.1,0-1.98.53-2.4,1.21h-.07l-.3-1.05h-1.03v9.52h1.35v-7.09c.45-.86,1.42-1.22,2.35-1.22.35,0,.72.03,1.07.14v-1.42h0Z"
            />
            <path
              class="sixCls-10"
              d="M94.56,341.89c-.58-.28-1.51-.49-2.71-.49-3.15,0-4.64,2.05-4.64,5.09,0,3.24,1.66,4.46,3.62,4.46,1.22,0,2.03-.49,2.33-.75h.07v.88c0,1.7-.7,2.54-2.43,2.54-1.28,0-2.03-.42-2.5-.89l-.79,1.09c.39.38,1.33,1.01,3.13,1.01,2.38,0,3.92-1.24,3.92-3.75v-9.19h0ZM93.22,342.85v5.99c-.45.6-1.26.93-2.01.93-1.35,0-2.61-.72-2.61-3.45,0-2.52,1.23-3.73,3.06-3.73.61,0,1.16.11,1.56.26h0Z"
            />
            <path
              class="sixCls-10"
              d="M103.53,349.22c-.4.35-1.26.72-2.21.72-1.91,0-2.89-.89-3.01-3.24h6.06c.07-.61.11-1.17.11-1.65,0-2.26-1.21-3.73-3.47-3.73-2.12,0-4.04,1.42-4.04,4.87s1.47,4.94,4.18,4.94c1.37,0,2.36-.39,2.99-.86l-.61-1.05h0ZM100.88,342.5c1.54,0,2.24.91,2.24,2.54,0,.12,0,.33-.02.54h-4.78c.12-2.29,1.31-3.08,2.56-3.08h0Z"
            />
            <path
              class="sixCls-10"
              d="M114.17,344.45c-.05-2.12-1.19-3.15-3.1-3.15-1.49,0-2.45.86-2.71,1.19h-.07l-.28-1h-1.03v9.52h1.37v-6.81c.33-.93,1.24-1.7,2.42-1.7,1.33,0,2.05.81,2.05,2.26v6.25h1.37v-6.57h0Z"
            />
            <path
              class="sixCls-10"
              d="M116.52,346.39c0,3.43,1.52,4.78,3.85,4.78,1.63,0,2.43-.58,2.82-1.02l-.84-.95c-.39.44-.98.75-1.86.75-1.59,0-2.57-1.03-2.57-3.75s1.03-3.68,2.57-3.68c.93,0,1.49.39,1.87.79l.91-1c-.35-.4-1.19-1-2.71-1-2.33,0-4.04,1.56-4.04,5.06h0Z"
            />
            <path
              class="sixCls-10"
              d="M124.17,354.49c.23.09.61.18,1.09.18,1.94,0,2.89-1.21,3.48-2.99l3.36-10.19h-1.42l-1.47,4.67c-.61,1.96-.82,2.77-.98,3.47h-.07c-.23-.82-.51-1.75-1.07-3.47l-1.54-4.67h-1.47l3.45,9.86c-.42,1.47-1.07,2.1-2.26,2.1-.26,0-.65-.07-.89-.16l-.21,1.21h0Z"
            />
            <path
              class="sixCls-10"
              d="M52.55,369.8c-.44.65-1.3,1.3-2.38,1.3s-1.72-.68-1.72-1.52c0-1.44,1.8-2,4.1-1.91v2.14h0ZM50.57,362.36c-1.98,0-2.87,1.1-3.2,1.56l1,.79c.28-.45.89-1.16,2.17-1.16s2.01.46,2.01,2.01v1.03c-3.38-.05-5.44.98-5.44,3.08,0,1.3.98,2.54,2.75,2.54,1.61,0,2.38-.75,2.84-1.28h.07c.23.65.79,1.16,1.73,1.16.18,0,.37-.04.49-.11v-1h-.24c-.67,0-.93-.58-.93-1.44v-4.31c0-2-1.21-2.89-3.24-2.89h0Z"
            />
            <path
              class="sixCls-10"
              d="M61.65,369.5c0,.81-.65,1.51-1.98,1.51-1.1,0-2.01-.45-2.59-1.05l-.84,1.02c.6.61,1.79,1.21,3.36,1.21,2.29,0,3.4-1.4,3.4-2.71,0-3.24-4.81-2.38-4.81-4.52,0-.77.58-1.42,1.87-1.42.74,0,1.51.32,1.94.77l.88-.95c-.58-.61-1.65-1.01-2.78-1.01-2.08,0-3.26,1.28-3.26,2.64,0,3.22,4.81,2.36,4.81,4.52h0Z"
            />
            <path
              class="sixCls-10"
              d="M69.95,369.5c0,.81-.65,1.51-1.98,1.51-1.1,0-2.01-.45-2.59-1.05l-.84,1.02c.6.61,1.79,1.21,3.36,1.21,2.29,0,3.4-1.4,3.4-2.71,0-3.24-4.81-2.38-4.81-4.52,0-.77.58-1.42,1.87-1.42.74,0,1.51.32,1.94.77l.88-.95c-.58-.61-1.65-1.01-2.78-1.01-2.08,0-3.26,1.28-3.26,2.64,0,3.22,4.81,2.36,4.81,4.52h0Z"
            />
            <path
              class="sixCls-10"
              d="M79.82,370.23c-.4.35-1.26.72-2.21.72-1.91,0-2.89-.89-3.01-3.24h6.06c.07-.61.1-1.17.1-1.65,0-2.26-1.21-3.73-3.47-3.73-2.12,0-4.04,1.42-4.04,4.87s1.47,4.94,4.18,4.94c1.37,0,2.36-.39,2.99-.86l-.61-1.05h0ZM77.18,363.51c1.54,0,2.24.91,2.24,2.54,0,.12,0,.33-.02.54h-4.78c.12-2.29,1.31-3.08,2.56-3.08h0Z"
            />
            <path
              class="sixCls-10"
              d="M89.73,363.81h-.07c-.35-.86-1.1-1.51-2.52-1.51-1.49,0-2.21.81-2.47,1.21h-.07l-.28-1.02h-1.05v9.52h1.37v-6.81c.19-.82.96-1.7,2.15-1.7s1.89.82,1.89,2.33v6.18h1.37v-6.92c.25-.77,1-1.59,2.19-1.59s1.87.75,1.87,2.22v6.29h1.35v-6.57c0-2.08-1.05-3.15-2.94-3.15-1.49,0-2.42.74-2.78,1.51h0Z"
            />
            <path
              class="sixCls-10"
              d="M98.31,371.69c.58.3,1.49.51,2.68.51,3.15,0,4.67-2.14,4.67-5.23,0-3.26-1.63-4.55-3.62-4.55-1.19,0-2.01.49-2.31.74h-.07v-4.41h-1.35v12.96h0ZM101.2,371c-.59,0-1.16-.11-1.52-.26v-6.2c.44-.6,1.24-.95,2-.95,1.33,0,2.63.79,2.63,3.55,0,2.57-1.24,3.85-3.1,3.85h0Z"
            />
            <path
              class="sixCls-10"
              d="M108.17,358.73v11.4c0,1.24.63,2.01,1.94,2.01.37,0,.84-.05,1.19-.21v-1.16c-.18.09-.44.19-.79.19-.72,0-1-.37-1-1.21v-11.03h-1.35Z"
            />
            <path
              class="sixCls-10"
              d="M112.12,375.5c.23.09.61.18,1.09.18,1.94,0,2.89-1.21,3.48-2.99l3.36-10.19h-1.42l-1.47,4.67c-.61,1.96-.82,2.77-.98,3.47h-.07c-.23-.82-.51-1.75-1.07-3.47l-1.54-4.67h-1.47l3.45,9.86c-.42,1.47-1.07,2.1-2.26,2.1-.26,0-.65-.07-.89-.16l-.21,1.21h0Z"
            />
            <path
              class="sixCls-10"
              d="M134.25,366.86c0-3.09-1.37-4.54-3.54-4.54-1.21,0-2.01.53-2.47,1.14h-.07l-.3-.96h-1.02v12.92h1.35v-3.55c.47.11,1.01.16,1.51.16,2.73,0,4.53-1.84,4.53-5.16h0ZM128.21,370.6v-5.78c.33-.61,1.01-1.33,2.19-1.33,1.26,0,2.47.85,2.47,3.53,0,2.53-1.07,3.79-3.22,3.79-.38,0-1.03-.07-1.44-.21h0Z"
            />
            <path
              class="sixCls-10"
              d="M137.54,367.17c0-2.47.68-3.68,2.49-3.68s2.61,1.24,2.61,3.8-.66,3.69-2.5,3.69-2.59-1.26-2.59-3.82h0ZM140.03,372.18c2.89,0,4.01-2.05,4.01-4.99s-1-4.87-3.9-4.87-3.99,2.01-3.99,4.96,1,4.9,3.89,4.9h0Z"
            />
            <path
              class="sixCls-10"
              d="M146.89,372.02h1.37v-9.52h-1.37v9.52h0ZM146.51,359.73c0,.56.44.98.98.98.58,0,1.02-.42,1.02-.98s-.44-1-1.02-1c-.54,0-.98.42-.98,1h0Z"
            />
            <path
              class="sixCls-10"
              d="M158.69,365.45c-.05-2.12-1.19-3.15-3.1-3.15-1.49,0-2.45.86-2.71,1.19h-.07l-.28-1h-1.03v9.52h1.37v-6.81c.33-.93,1.24-1.7,2.42-1.7,1.33,0,2.05.81,2.05,2.26v6.25h1.37v-6.57h0Z"
            />
            <path
              class="sixCls-10"
              d="M164.28,372.11c1.14,0,1.77-.23,2.14-.44l-.38-1.09c-.25.16-.68.33-1.45.33-.84,0-1.38-.44-1.38-1.51v-5.81h2.63v-1.1h-2.63v-2.5h-.93l-.42,2.47-1.42.26v.88h1.42v5.88c0,1.8.86,2.63,2.43,2.63h0Z"
            />
          </g>
          <g>
            <path
              class="sixCls-10"
              d="M7.52,240.88c-.77,0-1.4-.62-1.4-1.4v-9.3c0-.77.62-1.4,1.4-1.4s1.4.62,1.4,1.4v9.3c0,.77-.62,1.4-1.4,1.4h0Z"
            />
            <path
              class="sixCls-10"
              d="M14.19,235.8h-6.62c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h6.62c.53,0,.96.43.96.96s-.43.96-.96.96h0Z"
            />
            <path
              class="sixCls-10"
              d="M18.82,247.04c-.34,0-.68-.16-.89-.46l-4.08-5.69h-6.25c-.61,0-1.1-.49-1.1-1.1s.49-1.1,1.1-1.1h6.81c.35,0,.69.17.89.46l3.77,5.26,2.2-1.54c.5-.35,1.18-.23,1.53.27.35.5.23,1.18-.27,1.53l-3.09,2.17c-.19.13-.41.2-.63.2h0Z"
            />
            <path
              class="sixCls-10"
              d="M9.68,226.04c0,1.19-.96,2.15-2.15,2.15s-2.15-.96-2.15-2.15.96-2.15,2.15-2.15,2.15.96,2.15,2.15h0Z"
            />
            <path
              class="sixCls-10"
              d="M15.6,244.2c-1.17,1.92-3.28,3.2-5.68,3.2-3.66,0-6.64-2.98-6.64-6.64,0-2.02.91-3.83,2.34-5.05v-1.62c-2.19,1.42-3.64,3.88-3.64,6.67,0,4.38,3.56,7.95,7.95,7.95,2.68,0,5.05-1.33,6.49-3.37l-.81-1.14h0Z"
            />
            <path
              class="sixCls-10"
              d="M48.4,232.34h3.2c3.76,0,5.38-2.26,5.38-6.25s-1.66-6.02-5.36-6.02h-3.22v12.27h0ZM49.8,221.31h1.7c2.61,0,4.04,1.28,4.04,4.94s-1.26,4.85-3.96,4.85h-1.79v-9.79h0Z"
            />
            <path
              class="sixCls-10"
              d="M59.96,232.34h1.37v-9.52h-1.37v9.52h0ZM59.57,220.05c0,.56.44.98.98.98.58,0,1.02-.42,1.02-.98s-.44-1-1.02-1c-.54,0-.98.42-.98,1h0Z"
            />
            <path
              class="sixCls-10"
              d="M69.05,229.82c0,.81-.65,1.51-1.98,1.51-1.1,0-2.01-.45-2.59-1.05l-.84,1.02c.6.61,1.79,1.21,3.36,1.21,2.29,0,3.4-1.4,3.4-2.71,0-3.24-4.81-2.38-4.81-4.52,0-.77.58-1.42,1.87-1.42.74,0,1.51.32,1.94.77l.88-.95c-.58-.61-1.65-1.01-2.78-1.01-2.08,0-3.26,1.28-3.26,2.64,0,3.22,4.81,2.36,4.81,4.52h0Z"
            />
            <path
              class="sixCls-10"
              d="M77.78,230.12c-.44.65-1.3,1.3-2.38,1.3s-1.72-.68-1.72-1.52c0-1.44,1.8-2,4.1-1.91v2.14h0ZM75.8,222.68c-1.98,0-2.87,1.1-3.2,1.56l1,.79c.28-.45.89-1.16,2.17-1.16s2.01.46,2.01,2.01v1.03c-3.38-.05-5.44.98-5.44,3.08,0,1.3.98,2.54,2.75,2.54,1.61,0,2.38-.75,2.84-1.28h.07c.23.65.79,1.16,1.73,1.16.18,0,.37-.04.49-.11v-1h-.24c-.67,0-.93-.58-.93-1.44v-4.31c0-2-1.21-2.89-3.24-2.89h0Z"
            />
            <path
              class="sixCls-10"
              d="M82.4,232.01c.58.3,1.49.51,2.68.51,3.15,0,4.67-2.14,4.67-5.23,0-3.26-1.63-4.55-3.62-4.55-1.19,0-2.01.49-2.31.74h-.07v-4.41h-1.35v12.96h0ZM85.29,231.32c-.59,0-1.16-.11-1.52-.26v-6.2c.44-.6,1.24-.95,2-.95,1.33,0,2.63.79,2.63,3.55,0,2.57-1.24,3.85-3.1,3.85h0Z"
            />
            <path
              class="sixCls-10"
              d="M92.26,219.05v11.4c0,1.24.63,2.01,1.94,2.01.37,0,.84-.05,1.19-.21v-1.16c-.18.09-.44.19-.79.19-.72,0-1-.37-1-1.21v-11.03h-1.35Z"
            />
            <path
              class="sixCls-10"
              d="M103.25,230.55c-.4.35-1.26.72-2.21.72-1.91,0-2.89-.89-3.01-3.24h6.06c.07-.61.1-1.17.1-1.65,0-2.26-1.21-3.73-3.47-3.73-2.12,0-4.04,1.42-4.04,4.87s1.47,4.94,4.18,4.94c1.37,0,2.36-.39,2.99-.86l-.61-1.05h0ZM100.61,223.83c1.54,0,2.24.91,2.24,2.54,0,.12,0,.33-.02.54h-4.78c.12-2.29,1.31-3.08,2.56-3.08h0Z"
            />
            <path
              class="sixCls-10"
              d="M112.24,222.97c-.44-.09-.96-.16-1.52-.16-2.68,0-4.52,1.73-4.52,5.18,0,3.12,1.37,4.53,3.52,4.53,1.24,0,2.12-.6,2.49-1.16h.07l.3.96h1.01v-13.29h-1.35v3.92h0ZM110.01,231.36c-1.26,0-2.43-.86-2.43-3.52s1.1-3.83,3.2-3.83c.44,0,1.09.11,1.45.23v5.58c-.37.89-1.09,1.54-2.22,1.54h0Z"
            />
            <path
              class="sixCls-10"
              d="M53.45,245.23l1.94,8.12h1.84l2.56-9.52h-1.31l-1.35,5.23c-.26,1-.51,2.05-.74,3.08h-.07c-.19-.96-.4-1.82-.61-2.7l-1.4-5.62h-1.75l-1.43,5.62c-.23.88-.42,1.77-.61,2.7h-.07c-.21-1.05-.45-2.05-.72-3.06l-1.33-5.25h-1.4l2.52,9.52h1.84l2.03-8.12h.07Z"
            />
            <path
              class="sixCls-10"
              d="M66.33,251.13c-.44.65-1.3,1.3-2.38,1.3s-1.72-.68-1.72-1.52c0-1.44,1.8-2,4.1-1.91v2.14h0ZM64.35,243.69c-1.98,0-2.87,1.1-3.2,1.56l1,.79c.28-.45.89-1.16,2.17-1.16s2.01.46,2.01,2.01v1.03c-3.38-.05-5.44.98-5.44,3.08,0,1.3.98,2.54,2.75,2.54,1.61,0,2.38-.75,2.84-1.28h.07c.23.65.79,1.16,1.73,1.16.18,0,.37-.04.49-.11v-1h-.24c-.67,0-.93-.58-.93-1.44v-4.31c0-2-1.21-2.89-3.24-2.89h0Z"
            />
            <path
              class="sixCls-10"
              d="M75.44,250.83c0,.81-.65,1.51-1.98,1.51-1.1,0-2.01-.45-2.59-1.05l-.84,1.02c.6.61,1.79,1.21,3.36,1.21,2.29,0,3.4-1.4,3.4-2.71,0-3.24-4.81-2.38-4.81-4.52,0-.77.58-1.42,1.87-1.42.74,0,1.51.32,1.94.77l.88-.95c-.58-.61-1.65-1.01-2.78-1.01-2.08,0-3.26,1.28-3.26,2.64,0,3.22,4.81,2.36,4.81,4.52h0Z"
            />
            <path
              class="sixCls-10"
              d="M83.44,243.67c-1.61,0-2.47.88-2.75,1.21h-.07v-4.81h-1.37v13.29h1.37v-6.79c.33-.82,1.23-1.68,2.54-1.68s1.93.91,1.93,2.1v6.37h1.37v-6.58c0-1.94-1.17-3.1-3.01-3.1h0Z"
            />
            <path
              class="sixCls-10"
              d="M94.06,243.76c-.21-.05-.53-.09-.96-.09-1.1,0-1.98.53-2.4,1.21h-.07l-.3-1.05h-1.03v9.52h1.35v-7.09c.45-.86,1.42-1.22,2.35-1.22.35,0,.72.03,1.07.14v-1.42h0Z"
            />
            <path
              class="sixCls-10"
              d="M96.51,248.5c0-2.47.68-3.68,2.49-3.68s2.61,1.24,2.61,3.8-.66,3.69-2.5,3.69-2.59-1.26-2.59-3.82h0ZM99,253.51c2.89,0,4.01-2.05,4.01-4.99s-1-4.87-3.9-4.87-3.99,2.01-3.99,4.96,1,4.9,3.89,4.9h0Z"
            />
            <path
              class="sixCls-10"
              d="M106.3,248.5c0-2.47.68-3.68,2.49-3.68s2.61,1.24,2.61,3.8-.66,3.69-2.5,3.69-2.59-1.26-2.59-3.82h0ZM108.79,253.51c2.89,0,4.01-2.05,4.01-4.99s-1-4.87-3.9-4.87-3.99,2.01-3.99,4.96,1,4.9,3.89,4.9h0Z"
            />
            <path
              class="sixCls-10"
              d="M121.65,245.14h-.07c-.35-.86-1.1-1.51-2.52-1.51-1.49,0-2.21.81-2.47,1.21h-.07l-.28-1.02h-1.05v9.52h1.37v-6.81c.19-.82.96-1.7,2.15-1.7s1.89.82,1.89,2.33v6.18h1.37v-6.92c.25-.77,1-1.59,2.19-1.59s1.87.75,1.87,2.22v6.29h1.35v-6.57c0-2.08-1.05-3.15-2.94-3.15-1.49,0-2.42.74-2.78,1.51h0Z"
            />
          </g>
          <g>
            <polygon
              class="sixCls-12"
              points="8.35 408.8 14.35 408.8 14.35 402.42 20.73 402.42 20.73 396.41 14.35 396.41 14.35 390.03 8.35 390.03 8.35 396.41 1.97 396.41 1.97 402.42 8.35 402.42 8.35 408.8 8.35 408.8"
            />
            <polygon
              class="sixCls-10"
              points="48.64 405.96 48.64 400.69 53.09 400.69 53.09 399.45 48.64 399.45 48.64 394.93 53.7 394.93 53.7 393.69 47.22 393.69 47.22 405.96 48.64 405.96 48.64 405.96"
            />
            <path
              class="sixCls-10"
              d="M56.12,405.96h1.37v-9.52h-1.37v9.52h0ZM55.73,393.67c0,.56.44.98.98.98.58,0,1.02-.42,1.02-.98s-.44-1-1.02-1c-.54,0-.98.42-.98,1h0Z"
            />
            <path
              class="sixCls-10"
              d="M71.52,403.44c0,.81-.65,1.51-1.98,1.51-1.1,0-2.01-.45-2.59-1.05l-.84,1.02c.6.61,1.79,1.21,3.36,1.21,2.29,0,3.4-1.4,3.4-2.71,0-3.24-4.81-2.38-4.81-4.52,0-.77.58-1.42,1.87-1.42.74,0,1.51.32,1.94.77l.88-.95c-.58-.61-1.65-1.01-2.78-1.01-2.08,0-3.26,1.28-3.26,2.64,0,3.22,4.81,2.36,4.81,4.52h0Z"
            />
            <path
              class="sixCls-10"
              d="M78.07,406.05c1.14,0,1.77-.23,2.14-.44l-.38-1.09c-.25.16-.68.33-1.45.33-.84,0-1.38-.44-1.38-1.51v-5.81h2.63v-1.1h-2.63v-2.5h-.93l-.42,2.47-1.42.26v.88h1.42v5.88c0,1.8.86,2.63,2.43,2.63h0Z"
            />
            <path
              class="sixCls-10"
              d="M91.97,403.74c-.44.65-1.3,1.3-2.38,1.3s-1.72-.68-1.72-1.52c0-1.44,1.8-2,4.1-1.91v2.14h0ZM89.99,396.3c-1.98,0-2.87,1.1-3.2,1.56l1,.79c.28-.45.89-1.16,2.17-1.16s2.01.46,2.01,2.01v1.03c-3.38-.05-5.44.98-5.44,3.08,0,1.3.98,2.54,2.75,2.54,1.61,0,2.38-.75,2.84-1.28h.07c.23.65.79,1.16,1.73,1.16.18,0,.37-.04.49-.11v-1h-.24c-.67,0-.93-.58-.93-1.44v-4.31c0-2-1.21-2.89-3.24-2.89h0Z"
            />
            <path
              class="sixCls-10"
              d="M97.05,405.96h1.37v-9.52h-1.37v9.52h0ZM96.66,393.67c0,.56.44.98.98.98.58,0,1.02-.42,1.02-.98s-.44-1-1.02-1c-.54,0-.98.42-.98,1h0Z"
            />
            <path
              class="sixCls-10"
              d="M107.18,396.6c-.44-.09-.96-.16-1.52-.16-2.68,0-4.52,1.73-4.52,5.18,0,3.12,1.37,4.53,3.52,4.53,1.24,0,2.12-.6,2.49-1.16h.07l.3.96h1.01v-13.29h-1.35v3.92h0ZM104.96,404.98c-1.26,0-2.43-.86-2.43-3.52s1.1-3.83,3.2-3.83c.44,0,1.09.1,1.45.23v5.58c-.37.89-1.09,1.54-2.22,1.54h0Z"
            />
            <path
              class="sixCls-10"
              d="M65.48,396.37c-.21-.05-.53-.09-.96-.09-1.1,0-1.98.53-2.4,1.21h-.07l-.3-1.05h-1.03v9.52h1.35v-7.09c.45-.86,1.42-1.22,2.35-1.22.35,0,.72.03,1.07.14v-1.42h0Z"
            />
          </g>
          <g>
            <polygon
              class="sixCls-10"
              points="53.98 317.93 53.98 316.68 48.62 316.68 48.62 312.32 53.12 312.32 53.12 311.08 48.62 311.08 48.62 306.9 53.73 306.9 53.73 305.65 47.22 305.65 47.22 317.93 53.98 317.93 53.98 317.93"
            />
            <path
              class="sixCls-10"
              d="M62.72,309.72h-.07c-.35-.86-1.1-1.51-2.52-1.51-1.49,0-2.21.81-2.47,1.21h-.07l-.28-1.02h-1.05v9.52h1.37v-6.81c.19-.82.96-1.7,2.15-1.7s1.89.82,1.89,2.33v6.18h1.37v-6.92c.25-.77,1-1.59,2.19-1.59s1.87.75,1.87,2.22v6.29h1.35v-6.57c0-2.08-1.05-3.15-2.94-3.15-1.49,0-2.42.74-2.78,1.51h0Z"
            />
            <path
              class="sixCls-10"
              d="M77.35,316.14c-.4.35-1.26.72-2.21.72-1.91,0-2.89-.89-3.01-3.24h6.06c.07-.61.11-1.17.11-1.65,0-2.26-1.21-3.73-3.47-3.73-2.12,0-4.04,1.42-4.04,4.87s1.47,4.94,4.18,4.94c1.37,0,2.36-.39,2.99-.86l-.61-1.05h0ZM74.71,309.42c1.54,0,2.24.91,2.24,2.54,0,.12,0,.33-.02.54h-4.78c.12-2.29,1.31-3.08,2.56-3.08h0Z"
            />
            <path
              class="sixCls-10"
              d="M85.56,308.33c-.21-.05-.53-.09-.96-.09-1.1,0-1.98.53-2.4,1.21h-.07l-.3-1.05h-1.03v9.52h1.35v-7.09c.45-.86,1.42-1.22,2.35-1.22.35,0,.72.03,1.07.14v-1.42h0Z"
            />
            <path
              class="sixCls-10"
              d="M93.97,308.8c-.58-.28-1.51-.49-2.71-.49-3.15,0-4.64,2.05-4.64,5.09,0,3.24,1.66,4.46,3.62,4.46,1.23,0,2.03-.49,2.33-.75h.07v.88c0,1.7-.7,2.54-2.43,2.54-1.28,0-2.03-.42-2.5-.89l-.79,1.09c.39.38,1.33,1.01,3.13,1.01,2.38,0,3.92-1.24,3.92-3.75v-9.19h0ZM92.62,309.77v5.99c-.45.6-1.26.93-2.01.93-1.35,0-2.61-.72-2.61-3.45,0-2.52,1.23-3.73,3.06-3.73.61,0,1.16.11,1.56.26h0Z"
            />
            <path
              class="sixCls-10"
              d="M102.93,316.14c-.4.35-1.26.72-2.21.72-1.91,0-2.89-.89-3.01-3.24h6.06c.07-.61.11-1.17.11-1.65,0-2.26-1.21-3.73-3.47-3.73-2.12,0-4.04,1.42-4.04,4.87s1.47,4.94,4.18,4.94c1.37,0,2.36-.39,2.99-.86l-.61-1.05h0ZM100.29,309.42c1.54,0,2.24.91,2.24,2.54,0,.12,0,.33-.02.54h-4.78c.12-2.29,1.31-3.08,2.56-3.08h0Z"
            />
            <path
              class="sixCls-10"
              d="M113.57,311.36c-.05-2.12-1.19-3.15-3.1-3.15-1.49,0-2.45.86-2.71,1.19h-.07l-.28-1h-1.03v9.52h1.37v-6.81c.33-.93,1.24-1.7,2.42-1.7,1.33,0,2.05.81,2.05,2.26v6.25h1.37v-6.57h0Z"
            />
            <path
              class="sixCls-10"
              d="M115.92,313.3c0,3.43,1.52,4.78,3.85,4.78,1.63,0,2.43-.58,2.82-1.02l-.84-.95c-.39.44-.98.75-1.86.75-1.59,0-2.57-1.03-2.57-3.75s1.03-3.68,2.57-3.68c.93,0,1.49.39,1.87.79l.91-1c-.35-.4-1.19-1-2.71-1-2.33,0-4.04,1.56-4.04,5.06h0Z"
            />
            <path
              class="sixCls-10"
              d="M123.57,321.41c.23.09.61.18,1.09.18,1.94,0,2.89-1.21,3.48-2.99l3.36-10.19h-1.42l-1.47,4.67c-.61,1.96-.82,2.77-.98,3.47h-.07c-.23-.82-.51-1.75-1.07-3.47l-1.54-4.67h-1.47l3.45,9.86c-.42,1.47-1.07,2.1-2.26,2.1-.26,0-.65-.07-.89-.16l-.21,1.21h0Z"
            />
            <path
              class="sixCls-10"
              d="M144.37,316.14c-.4.35-1.26.72-2.21.72-1.91,0-2.89-.89-3.01-3.24h6.06c.07-.61.1-1.17.1-1.65,0-2.26-1.21-3.73-3.47-3.73-2.12,0-4.04,1.42-4.04,4.87s1.47,4.94,4.18,4.94c1.37,0,2.36-.39,2.99-.86l-.61-1.05h0ZM141.73,309.42c1.54,0,2.24.91,2.24,2.54,0,.12,0,.33-.02.54h-4.78c.12-2.29,1.31-3.08,2.56-3.08h0Z"
            />
            <polygon
              class="sixCls-10"
              points="152.86 317.93 154.44 317.93 151.37 313.01 154.26 308.4 152.67 308.4 150.64 311.94 150.57 311.94 148.43 308.4 146.86 308.4 149.76 312.97 146.68 317.93 148.28 317.93 150.5 314.06 150.57 314.06 152.86 317.93 152.86 317.93"
            />
            <path
              class="sixCls-10"
              d="M156.68,317.93h1.37v-9.52h-1.37v9.52h0ZM156.29,305.64c0,.56.44.98.98.98.58,0,1.02-.42,1.02-.98s-.44-1-1.02-1c-.54,0-.98.42-.98,1h0Z"
            />
            <path
              class="sixCls-10"
              d="M164.01,318.01c1.14,0,1.77-.23,2.14-.44l-.38-1.09c-.25.16-.68.33-1.45.33-.84,0-1.38-.44-1.38-1.51v-5.81h2.63v-1.1h-2.63v-2.5h-.93l-.42,2.47-1.42.26v.88h1.42v5.88c0,1.8.86,2.63,2.43,2.63h0Z"
            />
            <path
              class="sixCls-16"
              d="M8.2,302.18c-1.1-.29-1.93.6-2.12,1.42-.27,1.15.46,2.06,1.28,2.29,2.33.64,3.18-3.08.84-3.7h0ZM6.49,311.14l.46-.56c.23-.25.44-.72.74-.87.18.19.15.23.28.48l.71,1.35c.11.4.61,1.09.69,1.43.06.25-.44,1.24-.55,1.52l-3.18,7.53c-.16.38-.55,1.18-.6,1.5,1.98.12,2.19.08,2.76-1.12.4-.83.82-1.76,1.22-2.6.3-.63,2.31-4.98,2.49-5.16.24.73.37,2,.55,2.85.09.47.15.91.29,1.37.15.51.32.72.89.78h6.73c-.06-.33-.48-1.15-.63-1.49-.27-.61-.35-.83-1.17-.86-1.24-.04-2.87.11-4.04-.03-.19-1.18-.46-4.09-.82-4.98-.28-.7-.58-1.36-.87-2.02-.74-1.74-1.13-2.16-.25-2.18h1.74c.17.35,1.64,2.95,1.99,3.07.48.17.95-.22,1.06-.56.14-.45-.23-.91-.41-1.26-.45-.84-1.37-2.82-1.93-3.06-.42-.18-2.65-.09-3.3-.09-2.46,0-3.47-.38-4.91,1.81-.27.41-1.03,1.82-1.3,1.99-.15-.01-.14-.06-.11.05-.54.03-1.48.08-2.04,0v-9.2c1.37.1,3.17,0,4.61-.01l4.49-.02s.04,0,.05-.02c0-.02.03-.01.04-.02l5.6.02v15.98c1.67.21,1.47-.33,2.21,1.2.22.45,1,1.9,1.06,2.28h-3.21c-.07.5-.11,3.18.06,3.44.12.19.67.72.86.93.14.16.73.75.79.91-2.92.12-6.48,0-9.55,0-.85,0-.59.11-1.26-.64-.45-.5-.64-.85-1.07-.87-.6-.03-1.29,0-1.9,0,.07.23,0,.11.15.31l.48.5c.17.19.51.52.61.67-.5.06-1.65.05-2.18.02-.37-.02-.43-.23-.63-.46-.17-.19-.33-.34-.51-.53-.79-.82-.72-.66-.72-1.46.02-3.58-.07-7.25,0-10.8.73-.05,1.71.07,2.39-.02.63-.09.77-.77,1.16-1.13h0Z"
            />
          </g>
          <g>
            <polygon
              class="sixCls-10"
              points="48.64 283.83 48.64 278.56 53.09 278.56 53.09 277.31 48.64 277.31 48.64 272.8 53.7 272.8 53.7 271.55 47.22 271.55 47.22 283.83 48.64 283.83 48.64 283.83"
            />
            <path
              class="sixCls-10"
              d="M56.12,283.83h1.37v-9.52h-1.37v9.52h0ZM55.73,271.54c0,.56.44.98.98.98.58,0,1.02-.42,1.02-.98s-.44-1-1.02-1c-.54,0-.98.42-.98,1h0Z"
            />
            <path
              class="sixCls-10"
              d="M65.48,274.23c-.21-.05-.53-.09-.96-.09-1.1,0-1.98.53-2.4,1.21h-.07l-.3-1.05h-1.03v9.52h1.35v-7.09c.45-.86,1.42-1.22,2.35-1.22.35,0,.72.03,1.07.14v-1.42h0Z"
            />
            <path
              class="sixCls-10"
              d="M73.1,282.04c-.4.35-1.26.72-2.21.72-1.91,0-2.89-.89-3.01-3.24h6.06c.07-.61.1-1.17.1-1.65,0-2.26-1.21-3.73-3.47-3.73-2.12,0-4.04,1.42-4.04,4.87s1.47,4.94,4.18,4.94c1.37,0,2.36-.39,2.99-.86l-.61-1.05h0ZM70.45,275.32c1.54,0,2.24.91,2.24,2.54,0,.12,0,.33-.02.54h-4.78c.12-2.29,1.31-3.08,2.56-3.08h0Z"
            />
            <path
              class="sixCls-10"
              d="M87.65,282.04c-.4.35-1.26.72-2.21.72-1.91,0-2.89-.89-3.01-3.24h6.06c.07-.61.11-1.17.11-1.65,0-2.26-1.21-3.73-3.47-3.73-2.12,0-4.04,1.42-4.04,4.87s1.47,4.94,4.18,4.94c1.37,0,2.36-.39,2.99-.86l-.61-1.05h0ZM85,275.32c1.54,0,2.24.91,2.24,2.54,0,.12,0,.33-.02.54h-4.78c.12-2.29,1.31-3.08,2.56-3.08h0Z"
            />
            <polygon
              class="sixCls-10"
              points="96.14 283.83 97.71 283.83 94.65 278.91 97.54 274.3 95.94 274.3 93.91 277.84 93.84 277.84 91.71 274.3 90.13 274.3 93.04 278.87 89.96 283.83 91.55 283.83 93.77 279.96 93.84 279.96 96.14 283.83 96.14 283.83"
            />
            <path
              class="sixCls-10"
              d="M102.23,283.91c1.14,0,1.77-.23,2.14-.44l-.38-1.09c-.25.16-.68.33-1.45.33-.84,0-1.38-.44-1.38-1.51v-5.81h2.63v-1.1h-2.63v-2.5h-.93l-.42,2.47-1.42.26v.88h1.42v5.88c0,1.8.86,2.63,2.43,2.63h0Z"
            />
            <path
              class="sixCls-10"
              d="M106.62,283.83h1.37v-9.52h-1.37v9.52h0ZM106.24,271.54c0,.56.44.98.98.98.58,0,1.02-.42,1.02-.98s-.44-1-1.02-1c-.54,0-.98.42-.98,1h0Z"
            />
            <path
              class="sixCls-10"
              d="M118.42,277.26c-.05-2.12-1.19-3.15-3.1-3.15-1.49,0-2.45.86-2.71,1.19h-.07l-.28-1h-1.03v9.52h1.37v-6.81c.33-.93,1.24-1.7,2.42-1.7,1.33,0,2.05.81,2.05,2.26v6.25h1.37v-6.57h0Z"
            />
            <path
              class="sixCls-10"
              d="M128.12,274.7c-.58-.28-1.51-.49-2.71-.49-3.15,0-4.64,2.05-4.64,5.09,0,3.24,1.66,4.46,3.62,4.46,1.22,0,2.03-.49,2.33-.75h.07v.88c0,1.7-.7,2.54-2.43,2.54-1.28,0-2.03-.42-2.5-.89l-.79,1.09c.39.38,1.33,1.01,3.13,1.01,2.38,0,3.92-1.24,3.92-3.75v-9.19h0ZM126.78,275.67v5.99c-.45.6-1.26.93-2.01.93-1.35,0-2.61-.72-2.61-3.45,0-2.52,1.23-3.73,3.06-3.73.61,0,1.16.11,1.56.26h0Z"
            />
            <path
              class="sixCls-10"
              d="M130.98,280.81c.05,2.17,1.14,3.2,3.1,3.2,1.59,0,2.45-.82,2.71-1.19h.07l.26,1h1.07v-9.52h-1.37v6.25c-.03,1.51-1.03,2.29-2.4,2.29s-2.08-.75-2.08-2.31v-6.23h-1.37v6.51h0Z"
            />
            <path
              class="sixCls-10"
              d="M141.55,283.83h1.37v-9.52h-1.37v9.52h0ZM141.17,271.54c0,.56.44.98.98.98.58,0,1.02-.42,1.02-.98s-.44-1-1.02-1c-.54,0-.98.42-.98,1h0Z"
            />
            <path
              class="sixCls-10"
              d="M150.64,281.31c0,.81-.65,1.51-1.98,1.51-1.1,0-2.01-.45-2.59-1.05l-.84,1.02c.6.61,1.79,1.21,3.36,1.21,2.29,0,3.4-1.4,3.4-2.71,0-3.24-4.81-2.38-4.81-4.52,0-.77.58-1.42,1.87-1.42.74,0,1.51.32,1.94.77l.88-.95c-.58-.61-1.65-1.01-2.78-1.01-2.08,0-3.26,1.28-3.26,2.64,0,3.22,4.81,2.36,4.81,4.52h0Z"
            />
            <path
              class="sixCls-10"
              d="M158.64,274.14c-1.61,0-2.47.88-2.75,1.21h-.07v-4.81h-1.37v13.29h1.37v-6.79c.33-.82,1.23-1.68,2.54-1.68s1.93.91,1.93,2.1v6.37h1.37v-6.58c0-1.94-1.17-3.1-3.01-3.1h0Z"
            />
            <path
              class="sixCls-10"
              d="M170.56,282.04c-.4.35-1.26.72-2.21.72-1.91,0-2.89-.89-3.01-3.24h6.06c.07-.61.11-1.17.11-1.65,0-2.26-1.21-3.73-3.47-3.73-2.12,0-4.04,1.42-4.04,4.87s1.47,4.94,4.18,4.94c1.37,0,2.36-.39,2.99-.86l-.61-1.05h0ZM167.92,275.32c1.54,0,2.24.91,2.24,2.54,0,.12,0,.33-.02.54h-4.78c.12-2.29,1.31-3.08,2.56-3.08h0Z"
            />
            <path
              class="sixCls-10"
              d="M178.77,274.23c-.21-.05-.53-.09-.96-.09-1.1,0-1.98.53-2.4,1.21h-.07l-.3-1.05h-1.03v9.52h1.35v-7.09c.45-.86,1.42-1.22,2.35-1.22.35,0,.72.03,1.07.14v-1.42h0Z"
            />
            <path
              class="sixCls-16"
              d="M4.57,275.93s.02-.03.1-.04c0,0,.08,0,.09,0h5.89c.4,0,.29.01.32.09v3.76s-6.38,0-6.38,0c-.08-.08-.03.03-.06-.1v-.37c0-.4-.07-3.14.04-3.32h0ZM3.56,273.61c0,2.93-.01,5.88-.01,8.82s-.07,5.95,0,8.87h8.32s0-17.54,0-17.54c.04-.7-.42-1.27-.74-1.57-.59-.54-.86-.47-1.75-.58v-1.88c.4-.05.58.04.97-.1.27-.09.61-.14.83-.29v-1.27c-1.58-.42-.15-.26-2.06-.31v-1.07s-2.5-.01-2.5-.01v.93c-1.97.05-.85-.25-2.68,1.21-.23.18-.5.4-.7.61-.56.56-.78.51-1.06,1.56-.22.82-.19,1.59-.17,2.49h.94c.15-1.71,0-1.5,1.07-2.46.32-.28.6-.58.9-.88.4-.4.51-.61,1.28-.45v1.91c-.57.09-1.03-.12-1.8.49-.32.25-.83.87-.82,1.51h0Z"
            />
            <path
              class="sixCls-16"
              d="M25.73,284.81v-2.62c-.36-.15-.81-.27-1.2-.42-1.2-.49-2.16-1.1-3.11-1.89-.77-.65-1.7-1.82-2.27-2.73-.2-.33-.39-.73-.61-1.05-.15,1,.29,2.54.61,3.34.72,1.79,2.03,3.35,3.58,4.36.59.38,2.06,1.1,2.99,1.02h0Z"
            />
            <path
              class="sixCls-16"
              d="M17.32,271.96c.16.26.9.59,1.77,2.27,1.1,2.11,2.06,5.33,4.34,5.71.48.08,1.37.07,1.75-.17-.55-.36-1.08-.19-2.07-1.89-1.14-1.95-1.83-5.5-4.02-6.03-.73-.17-1.14-.02-1.77.11h0Z"
            />
            <path
              class="sixCls-16"
              d="M16.45,283.4c3.22.17,4.62,5.31,7.68,4.1.23-.09.41-.19.59-.3.21-.13.33-.24.49-.35-1.04-.36-1.54-.66-2.22-1.28-1.62-1.5-3.29-3.81-5.49-2.87-.3.13-.93.47-1.05.7h0Z"
            />
            <path
              class="sixCls-16"
              d="M25.73,291.34v-2.69c-.77.01-1.05.21-2.25.07-1.81-.22-3.73-1.07-4.82-2.29-.01.55.6,1.75.86,2.15,1.23,1.88,3.84,3.43,6.22,2.77h0Z"
            />
            <path
              class="sixCls-16"
              d="M25.73,277.95v-2.67c-.55-.44-.38-.17-1.18-.91-1.17-1.09-1.8-2.71-1.84-4.48l-.05.06c-.16.26-.28.78-.33,1.08-.09.45-.11.93-.09,1.4.04.88.25,1.73.54,2.45.34.82.67,1.29,1.14,1.85.25.3,1.17,1.19,1.82,1.22h0Z"
            />
          </g>
          <g>
            <path
              class="sixCls-7"
              d="M17.93,422.71H4c-1.12,0-2.03.91-2.03,2.03v13.93c0,1.12.91,2.03,2.03,2.03h13.93c1.12,0,2.03-.91,2.03-2.03v-13.93c0-1.12-.91-2.03-2.03-2.03h0Z"
            />
            <path
              class="sixCls-10"
              d="M10.47,433.3h-.91v3.91h-2.4v-11h3.77c2.23,0,3.84.83,3.84,3.26,0,2.06-1.08,3.83-4.3,3.83h0ZM10.54,428.23h-.97v3.11h.79c1.6,0,1.95-.69,1.95-1.54,0-1.08-.53-1.57-1.76-1.57h0Z"
            />
            <path
              class="sixCls-10"
              d="M50.76,424.17h-3.54v12.27h1.4v-4.85h1.87c2.82,0,4.24-1.45,4.24-3.9s-1.54-3.52-3.97-3.52h0ZM50.44,425.42c1.86,0,2.84.68,2.84,2.43,0,1.63-.75,2.52-2.78,2.52h-1.87v-4.95h1.82Z"
            />
            <path
              class="sixCls-10"
              d="M60.91,434.22c-.44.65-1.3,1.3-2.38,1.3s-1.72-.68-1.72-1.52c0-1.44,1.8-2,4.1-1.91v2.14h0ZM58.94,426.78c-1.98,0-2.87,1.1-3.2,1.56l1,.79c.28-.46.89-1.16,2.17-1.16s2.01.46,2.01,2.01v1.03c-3.38-.05-5.44.98-5.44,3.08,0,1.3.98,2.54,2.75,2.54,1.61,0,2.38-.75,2.84-1.28h.07c.23.65.79,1.16,1.73,1.16.18,0,.37-.04.49-.1v-1h-.24c-.67,0-.93-.58-.93-1.44v-4.31c0-2-1.21-2.89-3.24-2.89h0Z"
            />
            <path
              class="sixCls-10"
              d="M70.3,426.85c-.21-.05-.53-.09-.96-.09-1.1,0-1.98.53-2.4,1.21h-.07l-.3-1.05h-1.03v9.52h1.35v-7.09c.45-.86,1.42-1.23,2.35-1.23.35,0,.72.03,1.07.14v-1.42h0Z"
            />
            <path
              class="sixCls-10"
              d="M73.22,423.16h-1.37v13.29h1.37v-13.29h0ZM73.48,431.56l3.59,4.88h1.73l-3.73-4.92v-.07l3.52-4.53h-1.7l-3.41,4.57v.07h0Z"
            />
            <path
              class="sixCls-10"
              d="M81.08,436.45h1.37v-9.52h-1.37v9.52h0ZM80.7,424.16c0,.56.44.98.98.98.58,0,1.02-.42,1.02-.98s-.44-1-1.02-1c-.54,0-.98.42-.98,1h0Z"
            />
            <path
              class="sixCls-10"
              d="M92.88,429.88c-.05-2.12-1.19-3.15-3.1-3.15-1.49,0-2.45.86-2.71,1.19h-.07l-.28-1h-1.03v9.52h1.37v-6.81c.33-.93,1.24-1.7,2.42-1.7,1.33,0,2.05.81,2.05,2.26v6.25h1.37v-6.57h0Z"
            />
            <path
              class="sixCls-10"
              d="M102.58,427.32c-.58-.28-1.51-.49-2.71-.49-3.15,0-4.64,2.05-4.64,5.1,0,3.24,1.66,4.46,3.62,4.46,1.22,0,2.03-.49,2.33-.75h.07v.88c0,1.7-.7,2.54-2.43,2.54-1.28,0-2.03-.42-2.5-.89l-.79,1.09c.39.38,1.33,1.01,3.13,1.01,2.38,0,3.92-1.24,3.92-3.75v-9.19h0ZM101.23,428.29v5.99c-.45.6-1.26.93-2.01.93-1.35,0-2.61-.72-2.61-3.45,0-2.52,1.23-3.73,3.06-3.73.61,0,1.16.1,1.56.26h0Z"
            />
          </g>
          <g>
            <path
              class="sixCls-10"
              d="M10.19,123.17c0,1.24-1.01,2.25-2.25,2.25s-2.25-1.01-2.25-2.25,1.01-2.25,2.25-2.25,2.25,1.01,2.25,2.25h0Z"
            />
            <path
              class="sixCls-10"
              d="M13.9,134.06l-1.54-6.68c-.05-.75-.79-1.34-1.68-1.34h-5.45c-.9,0-1.63.59-1.68,1.34l-1.54,6.68c-.1.42.22.82.72.9.49.08.97-.19,1.07-.61l1.56-6.74s0-.02,0-.04h.32l-1.91,9.9c-.03.16.02.32.15.44.12.12.3.19.49.19h1.43v6.85c0,.42.41.77.91.77s.91-.34.91-.77v-6.85h.63v6.85c0,.43.41.77.91.77s.91-.34.91-.77v-6.85h1.43c.36,0,.65-.25.65-.55,0-.05,0-.11-.03-.16l-1.9-9.83h.32s0,.02,0,.04l1.56,6.74c.09.37.47.62.89.62.06,0,.12,0,.18-.01.49-.08.81-.48.72-.9h0Z"
            />
            <polygon
              class="sixCls-10"
              points="47.22 117.1 47.22 129.37 53.89 129.37 53.89 128.13 48.62 128.13 48.62 117.1 47.22 117.1 47.22 117.1"
            />
            <path
              class="sixCls-10"
              d="M60.55,127.15c-.44.65-1.3,1.3-2.38,1.3s-1.72-.68-1.72-1.52c0-1.44,1.8-2,4.1-1.91v2.14h0ZM58.57,119.7c-1.98,0-2.87,1.1-3.2,1.56l1,.79c.28-.45.89-1.16,2.17-1.16s2.01.46,2.01,2.01v1.03c-3.38-.05-5.44.98-5.44,3.08,0,1.3.98,2.54,2.75,2.54,1.61,0,2.38-.75,2.84-1.28h.07c.23.65.79,1.16,1.73,1.16.18,0,.37-.04.49-.11v-1h-.24c-.67,0-.93-.58-.93-1.44v-4.31c0-2-1.21-2.89-3.24-2.89h0Z"
            />
            <path
              class="sixCls-10"
              d="M70.7,120c-.44-.09-.96-.16-1.52-.16-2.68,0-4.52,1.73-4.52,5.18,0,3.12,1.37,4.53,3.52,4.53,1.24,0,2.12-.6,2.49-1.16h.07l.3.96h1.01v-13.29h-1.35v3.92h0ZM68.48,128.39c-1.26,0-2.43-.86-2.43-3.52s1.1-3.83,3.2-3.83c.44,0,1.09.11,1.45.23v5.58c-.37.89-1.09,1.54-2.22,1.54h0Z"
            />
            <path
              class="sixCls-10"
              d="M75.41,129.37h1.37v-9.52h-1.37v9.52h0ZM75.02,117.08c0,.56.44.98.98.98.58,0,1.02-.42,1.02-.98s-.44-1-1.02-1c-.54,0-.98.42-.98,1h0Z"
            />
            <path
              class="sixCls-10"
              d="M86.07,127.58c-.4.35-1.26.72-2.21.72-1.91,0-2.89-.89-3.01-3.24h6.06c.07-.61.11-1.17.11-1.65,0-2.26-1.21-3.73-3.47-3.73-2.12,0-4.04,1.42-4.04,4.87s1.47,4.94,4.18,4.94c1.37,0,2.36-.39,2.99-.86l-.61-1.05h0ZM83.43,120.86c1.54,0,2.24.91,2.24,2.54,0,.12,0,.33-.02.54h-4.78c.12-2.29,1.31-3.08,2.56-3.08h0Z"
            />
            <path
              class="sixCls-10"
              d="M94,126.85c0,.81-.65,1.51-1.98,1.51-1.1,0-2.01-.45-2.59-1.05l-.84,1.02c.6.61,1.79,1.21,3.36,1.21,2.29,0,3.4-1.4,3.4-2.71,0-3.24-4.81-2.38-4.81-4.52,0-.77.58-1.42,1.87-1.42.74,0,1.51.32,1.94.77l.87-.95c-.58-.61-1.65-1.01-2.78-1.01-2.08,0-3.26,1.28-3.26,2.64,0,3.22,4.81,2.36,4.81,4.52h0Z"
            />
            <path
              class="sixCls-10"
              d="M52.26,142.25l1.94,8.12h1.84l2.56-9.52h-1.31l-1.35,5.23c-.26,1-.51,2.05-.74,3.08h-.07c-.19-.96-.4-1.82-.61-2.7l-1.4-5.62h-1.75l-1.43,5.62c-.23.88-.42,1.77-.61,2.7h-.07c-.21-1.05-.45-2.05-.72-3.06l-1.33-5.25h-1.4l2.52,9.52h1.84l2.03-8.12h.07Z"
            />
            <path
              class="sixCls-10"
              d="M65.15,148.15c-.44.65-1.3,1.3-2.38,1.3s-1.72-.68-1.72-1.52c0-1.44,1.8-2,4.1-1.91v2.14h0ZM63.17,140.71c-1.98,0-2.87,1.1-3.2,1.56l1,.79c.28-.45.89-1.16,2.17-1.16s2.01.46,2.01,2.01v1.03c-3.38-.05-5.44.98-5.44,3.08,0,1.3.98,2.54,2.75,2.54,1.61,0,2.38-.75,2.84-1.28h.07c.23.65.79,1.16,1.73,1.16.18,0,.37-.04.49-.11v-1h-.24c-.67,0-.93-.58-.93-1.44v-4.31c0-2-1.21-2.89-3.24-2.89h0Z"
            />
            <path
              class="sixCls-10"
              d="M74.25,147.86c0,.81-.65,1.51-1.98,1.51-1.1,0-2.01-.45-2.59-1.05l-.84,1.02c.6.61,1.79,1.21,3.36,1.21,2.29,0,3.4-1.4,3.4-2.71,0-3.24-4.81-2.38-4.81-4.52,0-.77.58-1.42,1.87-1.42.74,0,1.51.32,1.94.77l.88-.95c-.58-.61-1.65-1.01-2.78-1.01-2.08,0-3.26,1.28-3.26,2.64,0,3.22,4.81,2.36,4.81,4.52h0Z"
            />
            <path
              class="sixCls-10"
              d="M82.25,140.7c-1.61,0-2.47.88-2.75,1.21h-.07v-4.81h-1.37v13.29h1.37v-6.79c.33-.82,1.23-1.68,2.54-1.68s1.93.91,1.93,2.1v6.37h1.37v-6.58c0-1.94-1.17-3.1-3.01-3.1h0Z"
            />
            <path
              class="sixCls-10"
              d="M92.88,140.78c-.21-.05-.53-.09-.96-.09-1.1,0-1.98.53-2.4,1.21h-.07l-.3-1.05h-1.03v9.52h1.35v-7.09c.45-.86,1.42-1.23,2.35-1.23.35,0,.72.03,1.07.14v-1.42h0Z"
            />
            <path
              class="sixCls-10"
              d="M95.33,145.53c0-2.47.68-3.68,2.49-3.68s2.61,1.24,2.61,3.8-.66,3.69-2.5,3.69-2.59-1.26-2.59-3.82h0ZM97.82,150.54c2.89,0,4.01-2.05,4.01-4.99s-1-4.87-3.9-4.87-3.99,2.01-3.99,4.96,1,4.9,3.89,4.9h0Z"
            />
            <path
              class="sixCls-10"
              d="M105.12,145.53c0-2.47.68-3.68,2.49-3.68s2.61,1.24,2.61,3.8-.67,3.69-2.5,3.69-2.59-1.26-2.59-3.82h0ZM107.6,150.54c2.89,0,4.01-2.05,4.01-4.99s-1-4.87-3.9-4.87-3.99,2.01-3.99,4.96,1,4.9,3.89,4.9h0Z"
            />
            <path
              class="sixCls-10"
              d="M120.47,142.17h-.07c-.35-.86-1.1-1.51-2.52-1.51-1.49,0-2.21.81-2.47,1.21h-.07l-.28-1.02h-1.05v9.52h1.37v-6.81c.19-.82.96-1.7,2.15-1.7s1.89.82,1.89,2.33v6.18h1.37v-6.92c.25-.77,1-1.59,2.19-1.59s1.87.75,1.87,2.22v6.29h1.35v-6.57c0-2.08-1.05-3.15-2.94-3.15-1.49,0-2.42.74-2.78,1.51h0Z"
            />
          </g>
          <g>
            <path
              class="sixCls-10"
              d="M8.55,174.63c0,1.23-.99,2.22-2.22,2.22s-2.22-1-2.22-2.22,1-2.22,2.22-2.22,2.22,1,2.22,2.22h0Z"
            />
            <path
              class="sixCls-10"
              d="M9.02,177.47H3.64c-.92,0-1.67.63-1.67,1.41v6.65c0,.42.4.76.9.76s.9-.34.9-.76v-6.55h.46v17.48c0,.42.4.76.9.76s.9-.34.9-.76v-9.63h.62v9.63c0,.42.4.76.9.76s.9-.34.9-.76v-17.47h.46v6.55c0,.42.4.76.9.76s.9-.34.9-.76v-6.65c0-.78-.75-1.41-1.67-1.41h0Z"
            />
            <path
              class="sixCls-10"
              d="M51.9,168.41c-2.92,0-5.27,1.93-5.27,6.36,0,4.18,1.68,6.27,4.85,6.27,1.89,0,3.06-.46,3.85-1.1v-5.3h-1.4v4.69c-.49.33-1.37.49-2.15.49-2.4,0-3.71-1.47-3.71-5.16,0-4.01,1.96-4.96,3.75-4.96,1.22,0,2.03.33,2.56.84l.91-1.07c-.4-.38-1.35-1.05-3.38-1.05h0Z"
            />
            <path
              class="sixCls-10"
              d="M64.21,179.07c-.4.35-1.26.72-2.21.72-1.91,0-2.89-.89-3.01-3.24h6.06c.07-.61.1-1.17.1-1.65,0-2.26-1.21-3.73-3.47-3.73-2.12,0-4.04,1.42-4.04,4.87s1.47,4.94,4.18,4.94c1.37,0,2.36-.39,2.99-.86l-.61-1.05h0ZM61.56,172.35c1.54,0,2.24.91,2.24,2.54,0,.12,0,.33-.02.54h-4.78c.12-2.29,1.31-3.08,2.56-3.08h0Z"
            />
            <path
              class="sixCls-10"
              d="M74.85,174.29c-.05-2.12-1.19-3.15-3.1-3.15-1.49,0-2.45.86-2.71,1.19h-.07l-.28-1h-1.03v9.52h1.37v-6.81c.33-.93,1.24-1.7,2.42-1.7,1.33,0,2.05.81,2.05,2.26v6.25h1.37v-6.57h0Z"
            />
            <path
              class="sixCls-10"
              d="M80.44,180.94c1.14,0,1.77-.23,2.14-.44l-.38-1.09c-.25.16-.68.33-1.45.33-.84,0-1.38-.44-1.38-1.51v-5.81h2.63v-1.1h-2.63v-2.5h-.93l-.42,2.47-1.42.26v.88h1.42v5.88c0,1.8.86,2.63,2.43,2.63h0Z"
            />
            <path
              class="sixCls-10"
              d="M88.86,178.33c0,.81-.65,1.51-1.98,1.51-1.1,0-2.01-.45-2.59-1.05l-.84,1.02c.6.61,1.79,1.21,3.36,1.21,2.29,0,3.4-1.4,3.4-2.71,0-3.24-4.81-2.38-4.81-4.52,0-.77.58-1.42,1.87-1.42.74,0,1.51.32,1.94.77l.88-.95c-.58-.61-1.65-1.01-2.78-1.01-2.08,0-3.26,1.28-3.26,2.64,0,3.22,4.81,2.36,4.81,4.52h0Z"
            />
            <path
              class="sixCls-10"
              d="M52.25,193.74l1.94,8.12h1.84l2.56-9.52h-1.31l-1.35,5.23c-.26,1-.51,2.05-.74,3.08h-.07c-.19-.96-.4-1.82-.61-2.7l-1.4-5.62h-1.75l-1.44,5.62c-.23.88-.42,1.77-.61,2.7h-.07c-.21-1.05-.45-2.05-.72-3.06l-1.33-5.25h-1.4l2.52,9.52h1.84l2.03-8.12h.07Z"
            />
            <path
              class="sixCls-10"
              d="M65.14,199.64c-.44.65-1.3,1.3-2.38,1.3s-1.72-.68-1.72-1.52c0-1.44,1.8-2,4.1-1.91v2.14h0ZM63.16,192.2c-1.98,0-2.87,1.1-3.2,1.56l1,.79c.28-.45.89-1.16,2.17-1.16s2.01.46,2.01,2.01v1.03c-3.38-.05-5.44.98-5.44,3.08,0,1.3.98,2.54,2.75,2.54,1.61,0,2.38-.75,2.84-1.28h.07c.23.65.79,1.16,1.73,1.16.18,0,.37-.04.49-.11v-1h-.24c-.67,0-.93-.58-.93-1.44v-4.31c0-2-1.21-2.89-3.24-2.89h0Z"
            />
            <path
              class="sixCls-10"
              d="M74.24,199.34c0,.81-.65,1.51-1.98,1.51-1.1,0-2.01-.45-2.59-1.05l-.84,1.02c.6.61,1.79,1.21,3.36,1.21,2.29,0,3.4-1.4,3.4-2.71,0-3.24-4.81-2.38-4.81-4.52,0-.77.58-1.42,1.87-1.42.74,0,1.51.32,1.94.77l.88-.95c-.58-.61-1.65-1.01-2.78-1.01-2.08,0-3.26,1.28-3.26,2.64,0,3.22,4.81,2.36,4.81,4.52h0Z"
            />
            <path
              class="sixCls-10"
              d="M82.24,192.18c-1.61,0-2.47.88-2.75,1.21h-.07v-4.81h-1.37v13.29h1.37v-6.79c.33-.82,1.23-1.68,2.54-1.68s1.93.91,1.93,2.1v6.37h1.37v-6.58c0-1.94-1.17-3.1-3.01-3.1h0Z"
            />
            <path
              class="sixCls-10"
              d="M92.87,192.27c-.21-.05-.53-.09-.96-.09-1.1,0-1.98.53-2.4,1.21h-.07l-.3-1.05h-1.03v9.52h1.35v-7.09c.45-.86,1.42-1.22,2.35-1.22.35,0,.72.03,1.07.14v-1.42h0Z"
            />
            <path
              class="sixCls-10"
              d="M95.32,197.01c0-2.47.68-3.68,2.49-3.68s2.61,1.24,2.61,3.8-.66,3.69-2.5,3.69-2.59-1.26-2.59-3.82h0ZM97.8,202.02c2.89,0,4.01-2.05,4.01-4.99s-1-4.87-3.9-4.87-3.99,2.01-3.99,4.96,1,4.9,3.89,4.9h0Z"
            />
            <path
              class="sixCls-10"
              d="M105.1,197.01c0-2.47.68-3.68,2.49-3.68s2.61,1.24,2.61,3.8-.66,3.69-2.5,3.69-2.59-1.26-2.59-3.82h0ZM107.59,202.02c2.89,0,4.01-2.05,4.01-4.99s-1-4.87-3.9-4.87-3.99,2.01-3.99,4.96,1,4.9,3.89,4.9h0Z"
            />
            <path
              class="sixCls-10"
              d="M120.46,193.65h-.07c-.35-.86-1.1-1.51-2.52-1.51-1.49,0-2.21.81-2.47,1.21h-.07l-.28-1.02h-1.05v9.52h1.37v-6.81c.19-.82.96-1.7,2.15-1.7s1.89.82,1.89,2.33v6.18h1.37v-6.92c.25-.77,1-1.59,2.19-1.59s1.87.75,1.87,2.22v6.29h1.35v-6.57c0-2.08-1.05-3.15-2.94-3.15-1.49,0-2.42.74-2.78,1.51h0Z"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              class="sixCls-10"
              d="M564.63,578.58l-2.13-2.38c-.17-.19-.42-.3-.68-.3l-3.46.05c-.49,0-.89.41-.89.9h0c0,.51.42.91.91.9l3.05-.05,1.01,1.12h-6.24l-8.76-1.34c-.33-.05-.63.07-.86.29v-2.38h-2.02v11.23l3.57-.99v7.66l3.57-.99v4.76l2.02-.57v-7.35l-3.57.99v-7.66l-3.57.99v-4.21c.15.14.33.25.55.28l8.66,1.32v.63l-1.18,3.53-3.25-.43c-.57-.07-1.08.32-1.16.89-.08.57.32,1.08.89,1.16l4.09.54c.49.07.96-.23,1.11-.69l1.03-3.08h4.26l-1.98,1.12c-.21.12-.37.32-.43.56-.06.24-.02.49.1.7l1.62,2.65c.26.43.81.56,1.24.3.42-.26.56-.81.3-1.24l-1.13-1.85,3.08-1.74c.22-.13.37-.34.43-.58.02-.03.04-.06.04-.1v-4.2s-.02-.06-.04-.09c-.04-.13-.1-.25-.19-.36Z"
            />
            <circle class="sixCls-10" cx="567.36" cy="581.1" r="2.02" />
            <path
              class="sixCls-10"
              d="M546.97,604.11c-.32.35-.65.99-.65,1.92,0,1.31.77,2.05,1.7,2.05,1.89,0,1.59-2.92,3.01-2.92.56,0,.96.43.96,1.15,0,.52-.18.89-.42,1.2l.54.43c.29-.35.52-.89.52-1.58,0-1.1-.72-1.9-1.65-1.9-1.93,0-1.62,2.92-3.01,2.92-.57,0-1.02-.45-1.02-1.28,0-.74.3-1.23.58-1.57l-.56-.41Z"
            />
            <path
              class="sixCls-10"
              d="M551.17,611.37v-1.31h1.25v-.46l-1.23-.21-.13-.71h-.44v.71h-2.94c-.9,0-1.31.43-1.31,1.22,0,.57.11.88.22,1.07l.54-.19c-.08-.12-.17-.34-.17-.73,0-.42.22-.69.75-.69h2.91v1.31h.55Z"
            />
            <path
              class="sixCls-10"
              d="M546.95,615.1v.03c-.32.11-.58.39-.58.87,0,.09.02.18.05.24h.5v-.12c0-.33.29-.46.72-.46h2.15c1,0,1.44-.6,1.44-1.62s-.55-1.44-.78-1.6l-.39.5c.23.14.58.45.58,1.09s-.23,1.01-1.01,1.01h-.52c.03-1.69-.49-2.72-1.54-2.72-.65,0-1.27.49-1.27,1.37,0,.81.38,1.19.64,1.42ZM547.63,612.98c.72,0,1,.9.95,2.05h-1.07c-.32-.22-.65-.65-.65-1.19s.34-.86.76-.86Z"
            />
            <path
              class="sixCls-10"
              d="M552.55,617.37c-.28,0-.49.22-.49.49,0,.29.21.51.49.51s.5-.22.5-.51c0-.27-.21-.49-.5-.49Z"
            />
            <rect
              class="sixCls-10"
              x="546.41"
              y="617.56"
              width="4.76"
              height=".68"
            />
            <path
              class="sixCls-10"
              d="M550.65,620.57v-.03l.53-.15v-.52h-4.76v.67h3.54c.43.23.61.71.61,1.17,0,.18-.02.36-.07.53h.71c.03-.1.04-.26.04-.48,0-.55-.26-.99-.6-1.2Z"
            />
            <path
              class="sixCls-10"
              d="M549.93,622.79c-1.61,0-1.18,2.41-2.26,2.41-.4,0-.75-.32-.75-.99,0-.55.23-1.01.53-1.3l-.51-.42c-.31.3-.6.89-.6,1.68,0,1.15.7,1.7,1.36,1.7,1.62,0,1.19-2.41,2.26-2.41.38,0,.71.29.71.94,0,.37-.16.75-.39.97l.47.44c.31-.29.51-.82.51-1.39,0-1.04-.64-1.63-1.32-1.63Z"
            />
          </g>
          <g>
            <g>
              <path
                class="sixCls-10"
                d="M586.89,595.59c-.23,0-.44.07-.61.17-.68.45-.52,1.5.24,1.79l.15.06c1.76.66,3.62,1,5.49,1h2.47c.47,0,.85-.38.85-.85v-1.51c0-.38-.31-.69-.69-.69l-7.92.03h0Z"
              />
              <path
                class="sixCls-10"
                d="M588.8,590.07c0,1.42-1.15,2.57-2.58,2.57s-2.57-1.15-2.57-2.57,1.15-2.58,2.57-2.58,2.58,1.15,2.58,2.58h0Z"
              />
              <path
                class="sixCls-10"
                d="M587.51,599.58l-3.52-2.37v-4.21c0-.23-.07-.44-.18-.61-.11-.23-.27-.44-.48-.6-.73-.57-1.78-.44-2.34.29l-4.58,5.88c-.06.08-.11.16-.16.25-.12.2-.19.43-.19.68v12.11c0,.73.59,1.31,1.31,1.31s1.31-.59,1.31-1.31v-10.66c.13-.09.25-.2.36-.34l2.66-3.41v1.23c0,.38.19.74.51.95l4.02,2.71c.2.13.42.2.64.2.37,0,.73-.18.95-.51.35-.52.22-1.24-.31-1.59h0Z"
              />
              <path
                class="sixCls-10"
                d="M594,595.83h-.7s-.06-.03-.06-.06v-.44s.02-.06.06-.06h.7s.06.02.06.06v.44s-.03.06-.06.06h0Z"
              />
              <path
                class="sixCls-10"
                d="M591.39,592.37h0c-.17-.07-.26-.26-.19-.44.07-.17.26-.26.43-.19.17.07.26.26.19.43-.05.13-.18.21-.31.21-.04,0-.08,0-.12-.02h0ZM590.32,592.62c-.14-.12-.16-.33-.04-.47.12-.14.33-.16.47-.04.14.12.16.33.05.47-.07.08-.16.12-.26.12-.08,0-.15-.03-.21-.08h0ZM592.09,592.98h0c-.12-.14-.09-.35.05-.47.14-.11.35-.09.47.05h0c.11.14.09.35-.05.47-.06.05-.13.07-.21.07-.1,0-.2-.04-.26-.12h0ZM589.72,593.57c-.16-.1-.2-.3-.11-.46.1-.16.3-.2.46-.11.16.1.2.31.11.46-.06.1-.17.15-.29.15-.06,0-.12-.02-.18-.05h0ZM592.68,593.86c-.09-.16-.04-.36.12-.46.16-.09.37-.04.46.12.09.16.04.36-.12.45-.05.03-.11.04-.17.04-.12,0-.23-.06-.29-.17h0ZM589.19,594.54c-.16-.09-.22-.29-.14-.45.09-.16.29-.22.45-.14.16.09.22.29.14.45-.06.11-.18.18-.3.18-.05,0-.11-.01-.16-.04h0ZM593.19,594.83h0c-.08-.17-.02-.37.15-.45.17-.08.37-.02.45.15.08.17.02.37-.15.45-.05.02-.1.03-.15.03-.12,0-.24-.07-.3-.19h0Z"
              />
              <path
                class="sixCls-10"
                d="M586.89,595.59c-.23,0-.44.07-.61.17-.68.45-.52,1.5.24,1.79l.15.06c1.76.66,3.62,1,5.49,1h2.47c.47,0,.85-.38.85-.85v-1.51c0-.38-.31-.69-.69-.69l-7.92.03h0Z"
              />
              <path
                class="sixCls-10"
                d="M588.8,590.07c0,1.42-1.15,2.57-2.58,2.57s-2.57-1.15-2.57-2.57,1.15-2.58,2.57-2.58,2.58,1.15,2.58,2.58h0Z"
              />
              <path
                class="sixCls-10"
                d="M587.51,599.58l-3.52-2.37v-4.21c0-.23-.07-.44-.18-.61-.11-.23-.27-.44-.48-.6-.73-.57-1.78-.44-2.34.29l-4.58,5.88c-.06.08-.11.16-.16.25-.12.2-.19.43-.19.68v12.11c0,.73.59,1.31,1.31,1.31s1.31-.59,1.31-1.31v-10.66c.13-.09.25-.2.36-.34l2.66-3.41v1.23c0,.38.19.74.51.95l4.02,2.71c.2.13.42.2.64.2.37,0,.73-.18.95-.51.35-.52.22-1.24-.31-1.59h0Z"
              />
              <path
                class="sixCls-10"
                d="M594,595.83h-.7s-.06-.03-.06-.06v-.44s.02-.06.06-.06h.7s.06.02.06.06v.44s-.03.06-.06.06h0Z"
              />
              <path
                class="sixCls-10"
                d="M591.39,592.37h0c-.17-.07-.26-.26-.19-.44.07-.17.26-.26.43-.19.17.07.26.26.19.43-.05.13-.18.21-.31.21-.04,0-.08,0-.12-.02h0ZM590.32,592.62c-.14-.12-.16-.33-.04-.47.12-.14.33-.16.47-.04.14.12.16.33.05.47-.07.08-.16.12-.26.12-.08,0-.15-.03-.21-.08h0ZM592.09,592.98h0c-.12-.14-.09-.35.05-.47.14-.11.35-.09.47.05h0c.11.14.09.35-.05.47-.06.05-.13.07-.21.07-.1,0-.2-.04-.26-.12h0ZM589.72,593.57c-.16-.1-.2-.3-.11-.46.1-.16.3-.2.46-.11.16.1.2.31.11.46-.06.1-.17.15-.29.15-.06,0-.12-.02-.18-.05h0ZM592.68,593.86c-.09-.16-.04-.36.12-.46.16-.09.37-.04.46.12.09.16.04.36-.12.45-.05.03-.11.04-.17.04-.12,0-.23-.06-.29-.17h0ZM589.19,594.54c-.16-.09-.22-.29-.14-.45.09-.16.29-.22.45-.14.16.09.22.29.14.45-.06.11-.18.18-.3.18-.05,0-.11-.01-.16-.04h0ZM593.19,594.83h0c-.08-.17-.02-.37.15-.45.17-.08.37-.02.45.15.08.17.02.37-.15.45-.05.02-.1.03-.15.03-.12,0-.24-.07-.3-.19h0Z"
              />
            </g>
            <g>
              <path
                class="sixCls-10"
                d="M584.42,620.17v1.6c0,1.88,1.13,2.69,3.12,2.69s3.01-.83,3.01-2.68v-1.61h-6.14ZM589.93,620.87v.85c0,1.3-.64,2.02-2.47,2.02s-2.43-.63-2.43-1.98v-.89h4.89Z"
              />
              <path
                class="sixCls-10"
                d="M589.22,628.1c.03-.1.04-.26.04-.48,0-.55-.26-.99-.6-1.2v-.03l.53-.15v-.52h-4.76v.67h3.54c.43.23.61.71.61,1.17,0,.18-.02.36-.07.53h.71Z"
              />
              <path
                class="sixCls-10"
                d="M584.42,629.11v.68h4.76v-.68h-4.76ZM590.56,628.92c-.28,0-.49.22-.49.49,0,.29.21.51.49.51s.5-.22.5-.51c0-.27-.21-.49-.5-.49h0Z"
              />
              <path
                class="sixCls-10"
                d="M587.7,635.01c1.06-.03,1.58-.6,1.58-1.55,0-.74-.43-1.23-.6-1.36v-.03l.5-.14v-.52h-4.76v.68h3.41c.46.17.85.62.85,1.21,0,.67-.4,1.02-1.13,1.02h-3.12v.68h3.28Z"
              />
              <path
                class="sixCls-10"
                d="M591.06,637.12v-.68h-6.64v.68h6.64ZM586.86,637.25l-2.44,1.79v.87l2.46-1.86h.03l2.27,1.76v-.85l-2.28-1.71h-.03Z"
              />
              <path
                class="sixCls-10"
                d="M584.42,641.05v.68h4.76v-.68h-4.76ZM590.56,640.86c-.28,0-.49.22-.49.49,0,.29.21.51.49.51s.5-.22.5-.51c0-.27-.21-.49-.5-.49h0Z"
              />
              <path
                class="sixCls-10"
                d="M587.7,646.95c1.06-.03,1.58-.6,1.58-1.55,0-.74-.43-1.23-.6-1.36v-.03l.5-.14v-.52h-4.76v.68h3.41c.46.17.85.62.85,1.21,0,.67-.4,1.02-1.13,1.02h-3.12v.68h3.28Z"
              />
              <path
                class="sixCls-10"
                d="M588.98,651.8c.14-.29.24-.75.24-1.36,0-1.58-1.02-2.32-2.55-2.32-1.62,0-2.23.83-2.23,1.81,0,.61.24,1.02.38,1.16v.03h-.44c-.85,0-1.27-.35-1.27-1.22,0-.64.21-1.02.45-1.25l-.54-.39c-.19.19-.51.67-.51,1.57,0,1.19.62,1.96,1.87,1.96h4.6ZM588.5,651.12h-2.99c-.3-.23-.46-.63-.46-1.01,0-.67.36-1.3,1.72-1.3,1.26,0,1.86.61,1.86,1.53,0,.31-.05.58-.13.78h0Z"
              />
              <path
                class="sixCls-10"
                d="M577.98,622.69l-4.06.97v.92l4.76,1.28v-.66l-2.62-.67c-.5-.13-1.02-.25-1.54-.37v-.04c.48-.1.91-.2,1.35-.31l2.81-.7v-.88l-2.81-.72c-.44-.11-.88-.21-1.35-.31v-.04c.53-.11,1.02-.23,1.53-.36l2.63-.67v-.7l-4.76,1.26v.92l4.06,1.01v.04h0Z"
              />
              <path
                class="sixCls-10"
                d="M575.03,629.15c-.32-.22-.65-.65-.65-1.19s.34-.86.76-.86c.72,0,1,.9.95,2.05h-1.07ZM578.75,628.16c0-.99-.55-1.44-.78-1.6l-.39.5c.23.14.58.45.58,1.09s-.23,1.01-1.01,1.01h-.52c.03-1.69-.49-2.72-1.54-2.72-.65,0-1.27.49-1.27,1.37,0,.81.38,1.19.64,1.42v.03c-.32.11-.58.39-.58.87,0,.09.02.18.05.24h.5v-.12c0-.33.29-.46.72-.46h2.15c1,0,1.44-.6,1.44-1.62h0Z"
              />
              <path
                class="sixCls-10"
                d="M573.87,632.83c0,.57.11.88.22,1.07l.54-.19c-.08-.12-.17-.34-.17-.73,0-.42.22-.69.75-.69h2.91v1.31h.55v-1.31h1.25v-.46l-1.23-.21-.13-.71h-.44v.71h-2.94c-.9,0-1.31.43-1.31,1.22h0Z"
              />
              <path
                class="sixCls-10"
                d="M574.81,637.83c-.17-.2-.36-.63-.36-1.1,0-.95.45-1.45,1.62-1.51v3.03c.31.03.59.05.82.05,1.13,0,1.86-.6,1.86-1.73,0-1.06-.71-2.02-2.43-2.02s-2.47.74-2.47,2.09c0,.68.19,1.18.43,1.5l.53-.31h0ZM578.17,636.51c0,.77-.45,1.12-1.27,1.12-.06,0-.17,0-.27,0v-2.39c1.15.06,1.54.66,1.54,1.28h0Z"
              />
              <path
                class="sixCls-10"
                d="M578.71,641.93c.03-.11.04-.26.04-.48,0-.55-.26-.99-.6-1.2v-.03l.53-.15v-.52h-4.76v.67h3.55c.43.23.61.71.61,1.17,0,.18-.02.36-.07.53h.71Z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                class="sixCls-16"
                d="M574.33,670.34s.02-.03.1-.04c0,0,.08,0,.09,0h5.89c.4,0,.29.01.32.09v3.76s-6.38,0-6.38,0c-.08-.08-.03.03-.06-.1v-.37c0-.4-.07-3.14.04-3.32h0ZM573.32,668.01c0,2.93-.01,5.88-.01,8.82s-.07,5.95,0,8.87h8.32s0-17.54,0-17.54c.04-.7-.42-1.27-.74-1.57-.59-.54-.86-.47-1.75-.58v-1.88c.4-.05.58.04.97-.1.27-.09.61-.14.83-.29v-1.27c-1.58-.42-.15-.26-2.06-.31v-1.07s-2.5-.01-2.5-.01v.93c-1.97.05-.85-.25-2.68,1.21-.23.18-.5.4-.7.61-.56.56-.78.51-1.06,1.56-.22.82-.19,1.59-.17,2.49h.94c.15-1.71,0-1.5,1.07-2.46.32-.28.6-.58.9-.87.4-.4.51-.61,1.28-.45v1.91c-.57.09-1.03-.12-1.8.49-.32.25-.83.87-.82,1.51h0Z"
              />
              <path
                class="sixCls-16"
                d="M595.49,679.22v-2.62c-.36-.15-.81-.27-1.2-.42-1.2-.49-2.16-1.1-3.11-1.89-.77-.65-1.7-1.82-2.27-2.73-.2-.33-.39-.73-.61-1.05-.15,1,.29,2.54.61,3.34.72,1.79,2.03,3.35,3.58,4.36.59.38,2.06,1.1,2.99,1.02h0Z"
              />
              <path
                class="sixCls-16"
                d="M587.08,666.37c.16.26.9.59,1.77,2.27,1.1,2.11,2.06,5.33,4.34,5.71.48.08,1.37.07,1.75-.17-.55-.36-1.08-.19-2.07-1.89-1.14-1.95-1.83-5.5-4.02-6.03-.73-.17-1.14-.02-1.77.11h0Z"
              />
              <path
                class="sixCls-16"
                d="M586.21,677.8c3.22.17,4.62,5.31,7.68,4.1.23-.09.41-.19.59-.3.21-.13.33-.24.49-.35-1.04-.36-1.54-.66-2.22-1.28-1.62-1.5-3.29-3.81-5.49-2.87-.3.13-.93.47-1.05.7h0Z"
              />
              <path
                class="sixCls-16"
                d="M595.49,685.75v-2.69c-.77.01-1.05.21-2.25.07-1.81-.22-3.73-1.07-4.82-2.29-.01.55.6,1.75.86,2.15,1.23,1.88,3.84,3.43,6.22,2.77h0Z"
              />
              <path
                class="sixCls-16"
                d="M595.49,672.36v-2.67c-.55-.44-.38-.17-1.18-.91-1.17-1.09-1.8-2.71-1.84-4.48l-.05.06c-.16.26-.28.78-.33,1.08-.09.45-.11.93-.09,1.4.04.88.25,1.73.54,2.45.34.82.67,1.29,1.14,1.85.25.3,1.17,1.19,1.82,1.22h0Z"
              />
            </g>
            <g>
              <polygon
                class="sixCls-10"
                points="584.42 689.98 587.05 689.98 587.05 692.21 587.68 692.21 587.68 689.98 589.93 689.98 589.93 692.51 590.56 692.51 590.56 689.28 584.42 689.28 584.42 689.98 584.42 689.98"
              />
              <path
                class="sixCls-10"
                d="M584.42,693.72v.68h4.76v-.68h-4.76ZM590.56,693.53c-.28,0-.49.22-.49.49,0,.29.21.51.49.51s.5-.22.5-.51c0-.27-.21-.49-.5-.49h0Z"
              />
              <path
                class="sixCls-10"
                d="M589.22,698.4c.03-.11.04-.26.04-.48,0-.55-.26-.99-.6-1.2v-.03l.53-.15v-.52h-4.76v.67h3.54c.43.23.61.71.61,1.17,0,.18-.02.36-.07.53h.71Z"
              />
              <path
                class="sixCls-10"
                d="M585.31,702.21c-.17-.2-.36-.63-.36-1.1,0-.95.45-1.44,1.62-1.51v3.03c.31.03.59.05.82.05,1.13,0,1.86-.6,1.86-1.73,0-1.06-.71-2.02-2.43-2.02s-2.47.74-2.47,2.09c0,.68.19,1.18.43,1.5l.53-.31h0ZM588.67,700.89c0,.77-.45,1.12-1.27,1.12-.06,0-.17,0-.27,0v-2.39c1.15.06,1.54.66,1.54,1.28h0Z"
              />
              <path
                class="sixCls-10"
                d="M574.81,692.21c-.17-.2-.36-.63-.36-1.1,0-.95.45-1.45,1.62-1.51v3.03c.31.03.59.05.82.05,1.13,0,1.86-.6,1.86-1.73,0-1.06-.71-2.02-2.43-2.02s-2.47.74-2.47,2.09c0,.68.19,1.18.43,1.5l.53-.31h0ZM578.17,690.89c0,.77-.45,1.12-1.27,1.12-.06,0-.17,0-.27,0v-2.39c1.15.06,1.54.66,1.54,1.28h0Z"
              />
              <polygon
                class="sixCls-10"
                points="573.92 696.45 573.92 697.24 576.38 695.71 578.68 697.15 578.68 696.36 576.91 695.34 576.91 695.31 578.68 694.24 578.68 693.45 576.39 694.9 573.92 693.36 573.92 694.16 575.85 695.27 575.85 695.31 573.92 696.45 573.92 696.45"
              />
              <path
                class="sixCls-10"
                d="M573.87,699.5c0,.57.11.88.22,1.07l.54-.19c-.08-.12-.17-.34-.17-.73,0-.42.22-.69.75-.69h2.91v1.31h.55v-1.31h1.25v-.46l-1.23-.21-.13-.71h-.44v.71h-2.94c-.9,0-1.31.43-1.31,1.22h0Z"
              />
              <path
                class="sixCls-10"
                d="M573.92,701.7v.68h4.76v-.68h-4.76ZM580.06,701.5c-.28,0-.49.22-.49.49,0,.29.21.51.49.51s.5-.22.5-.51c0-.27-.21-.49-.5-.49h0Z"
              />
              <path
                class="sixCls-10"
                d="M577.2,707.6c1.06-.03,1.58-.6,1.58-1.55,0-.74-.43-1.23-.6-1.36v-.03l.5-.14v-.52h-4.76v.68h3.41c.46.17.85.62.85,1.21,0,.67-.4,1.02-1.13,1.02h-3.12v.68h3.28Z"
              />
              <path
                class="sixCls-10"
                d="M578.48,712.44c.14-.29.24-.75.24-1.36,0-1.58-1.02-2.32-2.55-2.32-1.62,0-2.23.83-2.23,1.81,0,.61.24,1.02.38,1.16v.03h-.44c-.85,0-1.27-.35-1.27-1.22,0-.64.21-1.02.45-1.25l-.54-.39c-.19.19-.51.67-.51,1.57,0,1.19.62,1.96,1.87,1.96h4.6ZM578,711.77h-2.99c-.3-.23-.46-.63-.46-1.01,0-.67.36-1.3,1.72-1.3,1.26,0,1.86.61,1.86,1.53,0,.31-.05.58-.13.78h0Z"
              />
              <path
                class="sixCls-10"
                d="M575.42,713.87c-1.09.03-1.6.57-1.6,1.55,0,.8.41,1.22.59,1.36v.04l-.5.13v.53h4.76v-.68h-3.12c-.75-.02-1.15-.52-1.15-1.2s.38-1.04,1.16-1.04h3.12v-.68h-3.26Z"
              />
              <path
                class="sixCls-10"
                d="M573.92,719.16v.68h4.76v-.68h-4.76ZM580.06,718.97c-.28,0-.49.22-.49.49,0,.29.21.51.49.51s.5-.22.5-.51c0-.27-.21-.49-.5-.49h0Z"
              />
              <path
                class="sixCls-10"
                d="M575.18,723.7c-.4,0-.75-.32-.75-.99,0-.55.23-1.01.53-1.3l-.51-.42c-.31.3-.6.89-.6,1.68,0,1.15.7,1.7,1.36,1.7,1.62,0,1.19-2.41,2.26-2.41.38,0,.71.29.71.94,0,.37-.16.75-.39.97l.47.44c.31-.29.51-.82.51-1.39,0-1.04-.64-1.63-1.32-1.63-1.61,0-1.18,2.41-2.26,2.41h0Z"
              />
              <path
                class="sixCls-10"
                d="M578.76,727.7c0-.81-.44-1.23-.6-1.37v-.03h2.41v-.68h-6.64v.68h3.4c.41.17.84.61.84,1.27s-.45.96-1.05.96h-3.19v.68h3.29c.97,0,1.55-.59,1.55-1.51h0Z"
              />
              <path
                class="sixCls-10"
                d="M574.81,733.66c-.17-.2-.36-.63-.36-1.1,0-.95.45-1.44,1.62-1.51v3.03c.31.03.59.05.82.05,1.13,0,1.86-.6,1.86-1.73,0-1.06-.71-2.02-2.43-2.02s-2.47.74-2.47,2.09c0,.68.19,1.18.43,1.5l.53-.31h0ZM578.17,732.34c0,.77-.45,1.12-1.27,1.12-.06,0-.17,0-.27,0v-2.39c1.15.06,1.54.66,1.54,1.28h0Z"
              />
              <path
                class="sixCls-10"
                d="M578.71,737.77c.03-.11.04-.26.04-.48,0-.55-.26-.99-.6-1.2v-.03l.53-.15v-.52h-4.76v.67h3.55c.43.23.61.71.61,1.17,0,.18-.02.36-.07.53h.71Z"
              />
            </g>
          </g>
          <g>
            <g>
              <polygon
                class="sixCls-10"
                points="622.76 471.35 622.76 470.73 620.08 470.73 620.08 468.55 622.33 468.55 622.33 467.93 620.08 467.93 620.08 465.83 622.64 465.83 622.64 465.21 619.38 465.21 619.38 471.35 622.76 471.35 622.76 471.35"
              />
              <path
                class="sixCls-10"
                d="M627.13,467.24h-.04c-.17-.43-.55-.75-1.26-.75-.74,0-1.1.4-1.23.6h-.03l-.14-.51h-.53v4.76h.68v-3.41c.1-.41.48-.85,1.08-.85s.95.41.95,1.16v3.09h.68v-3.46c.12-.39.5-.8,1.09-.8s.94.38.94,1.11v3.14h.67v-3.28c0-1.04-.53-1.58-1.47-1.58-.74,0-1.21.37-1.39.75h0Z"
              />
              <path
                class="sixCls-10"
                d="M634.44,470.46c-.2.17-.63.36-1.1.36-.95,0-1.44-.45-1.51-1.62h3.03c.03-.31.05-.59.05-.82,0-1.13-.6-1.86-1.73-1.86-1.06,0-2.02.71-2.02,2.43s.74,2.47,2.09,2.47c.68,0,1.18-.19,1.5-.43l-.31-.53h0ZM633.12,467.1c.77,0,1.12.45,1.12,1.27,0,.06,0,.17,0,.27h-2.39c.06-1.15.66-1.54,1.28-1.54h0Z"
              />
              <path
                class="sixCls-10"
                d="M638.55,466.55c-.11-.03-.26-.04-.48-.04-.55,0-.99.26-1.2.6h-.03l-.15-.53h-.52v4.76h.67v-3.54c.23-.43.71-.61,1.17-.61.18,0,.36.02.53.07v-.71h0Z"
              />
              <path
                class="sixCls-10"
                d="M642.75,466.79c-.29-.14-.75-.24-1.36-.24-1.58,0-2.32,1.02-2.32,2.55,0,1.62.83,2.23,1.81,2.23.61,0,1.02-.24,1.16-.38h.03v.44c0,.85-.35,1.27-1.22,1.27-.64,0-1.02-.21-1.25-.45l-.39.54c.19.19.67.51,1.57.51,1.19,0,1.96-.62,1.96-1.87v-4.6h0ZM642.08,467.27v2.99c-.23.3-.63.46-1.01.46-.67,0-1.3-.36-1.3-1.72,0-1.26.61-1.86,1.53-1.86.31,0,.58.05.78.13h0Z"
              />
              <path
                class="sixCls-10"
                d="M647.23,470.46c-.2.17-.63.36-1.1.36-.95,0-1.44-.45-1.51-1.62h3.03c.03-.31.05-.59.05-.82,0-1.13-.6-1.86-1.73-1.86-1.06,0-2.02.71-2.02,2.43s.74,2.47,2.09,2.47c.68,0,1.18-.19,1.5-.43l-.31-.53h0ZM645.91,467.1c.77,0,1.12.45,1.12,1.27,0,.06,0,.17,0,.27h-2.39c.06-1.15.66-1.54,1.28-1.54h0Z"
              />
              <path
                class="sixCls-10"
                d="M652.56,468.07c-.03-1.06-.6-1.58-1.55-1.58-.74,0-1.23.43-1.36.6h-.03l-.14-.5h-.52v4.76h.68v-3.41c.17-.46.62-.85,1.21-.85.67,0,1.02.4,1.02,1.13v3.12h.68v-3.28h0Z"
              />
              <path
                class="sixCls-10"
                d="M653.73,469.04c0,1.72.76,2.39,1.93,2.39.81,0,1.22-.29,1.41-.51l-.42-.47c-.19.22-.49.38-.93.38-.8,0-1.29-.52-1.29-1.87s.52-1.84,1.29-1.84c.46,0,.74.19.94.39l.46-.5c-.18-.2-.6-.5-1.36-.5-1.16,0-2.02.78-2.02,2.53h0Z"
              />
              <path
                class="sixCls-10"
                d="M657.55,473.09c.11.04.31.09.54.09.97,0,1.44-.6,1.74-1.5l1.68-5.09h-.71l-.74,2.34c-.31.98-.41,1.38-.49,1.73h-.03c-.11-.41-.25-.88-.53-1.73l-.77-2.34h-.74l1.72,4.93c-.21.74-.53,1.05-1.13,1.05-.13,0-.32-.03-.45-.08l-.11.6h0Z"
              />
              <path
                class="sixCls-10"
                d="M667.95,470.46c-.2.17-.63.36-1.1.36-.95,0-1.44-.45-1.51-1.62h3.03c.03-.31.05-.59.05-.82,0-1.13-.6-1.86-1.73-1.86-1.06,0-2.02.71-2.02,2.43s.74,2.47,2.09,2.47c.68,0,1.18-.19,1.5-.43l-.31-.53h0ZM666.63,467.1c.77,0,1.12.45,1.12,1.27,0,.06,0,.17,0,.27h-2.39c.06-1.15.66-1.54,1.28-1.54h0Z"
              />
              <polygon
                class="sixCls-10"
                points="672.2 471.35 672.99 471.35 671.45 468.89 672.9 466.59 672.1 466.59 671.09 468.36 671.05 468.36 669.98 466.59 669.2 466.59 670.65 468.87 669.11 471.35 669.9 471.35 671.02 469.41 671.05 469.41 672.2 471.35 672.2 471.35"
              />
              <path
                class="sixCls-10"
                d="M674.11,471.35h.68v-4.76h-.68v4.76h0ZM673.91,465.2c0,.28.22.49.49.49.29,0,.51-.21.51-.49s-.22-.5-.51-.5c-.27,0-.49.21-.49.5h0Z"
              />
              <path
                class="sixCls-10"
                d="M677.77,471.39c.57,0,.88-.11,1.07-.22l-.19-.54c-.12.08-.34.17-.73.17-.42,0-.69-.22-.69-.75v-2.91h1.31v-.55h-1.31v-1.25h-.46l-.21,1.23-.71.13v.44h.71v2.94c0,.9.43,1.31,1.22,1.31h0Z"
              />
            </g>
            <g>
              <path
                class="sixCls-16"
                d="M605.25,460.56c-.84-.22-1.47.46-1.62,1.08-.21.88.35,1.58.98,1.75,1.78.49,2.43-2.35.64-2.83h0ZM603.94,467.42l.35-.43c.18-.19.33-.55.57-.67.14.15.11.18.21.37l.54,1.03c.09.31.47.83.53,1.09.05.19-.33.95-.42,1.17l-2.43,5.76c-.12.29-.42.9-.46,1.15,1.51.1,1.68.06,2.11-.85.3-.63.63-1.34.93-1.98.23-.48,1.76-3.8,1.9-3.95.18.56.29,1.53.42,2.18.07.36.12.7.22,1.05.11.39.25.55.68.6h5.15c-.05-.25-.37-.88-.48-1.14-.21-.46-.26-.64-.89-.66-.95-.03-2.19.08-3.09-.02-.15-.9-.35-3.12-.63-3.8-.22-.53-.45-1.04-.66-1.54-.56-1.33-.86-1.65-.19-1.67h1.33c.13.27,1.25,2.25,1.52,2.35.37.13.73-.17.81-.43.11-.34-.17-.69-.32-.96-.34-.64-1.04-2.15-1.48-2.34-.32-.14-2.03-.07-2.52-.07-1.88,0-2.66-.29-3.76,1.39-.21.31-.79,1.39-1,1.53-.11,0-.11-.05-.09.04-.42.03-1.13.06-1.56,0v-7.04c1.05.07,2.42,0,3.52,0l3.43-.02s.03,0,.04-.01c0-.01.02,0,.03-.02l4.28.02v12.22c1.28.16,1.12-.25,1.69.92.17.34.77,1.45.81,1.74h-2.45c-.05.38-.08,2.43.05,2.63.09.14.51.55.66.71.11.12.56.58.61.69-2.23.09-4.96,0-7.3,0-.65,0-.45.08-.96-.49-.34-.38-.49-.65-.82-.67-.46-.02-.99,0-1.45,0,.06.17,0,.09.12.23l.36.38c.13.14.39.4.47.51-.38.05-1.26.03-1.67.02-.28-.01-.33-.18-.48-.35-.13-.14-.25-.26-.39-.41-.61-.63-.55-.51-.55-1.11.01-2.74-.06-5.54,0-8.26.56-.04,1.31.05,1.82-.02.48-.06.58-.59.89-.86h0Z"
              />
              <polygon
                class="sixCls-10"
                points="580.47 468.92 580.47 483.08 575.92 479.75 574.17 482.13 581.94 487.82 581.94 487.82 581.94 487.82 589.71 482.13 587.97 479.75 583.42 483.08 583.42 468.92 595.39 468.92 595.39 465.96 580.47 465.96 580.47 468.92 580.47 468.92 580.47 468.92"
              />
            </g>
          </g>
          <g>
            <g>
              <polygon
                class="sixCls-10"
                points="277.02 550.67 277.02 550.05 274.34 550.05 274.34 547.87 276.59 547.87 276.59 547.25 274.34 547.25 274.34 545.15 276.9 545.15 276.9 544.53 273.64 544.53 273.64 550.67 277.02 550.67 277.02 550.67"
              />
              <path
                class="sixCls-10"
                d="M281.39,546.56h-.04c-.17-.43-.55-.75-1.26-.75-.74,0-1.1.4-1.23.6h-.03l-.14-.51h-.53v4.76h.68v-3.41c.1-.41.48-.85,1.08-.85s.95.41.95,1.16v3.09h.68v-3.46c.12-.39.5-.8,1.09-.8s.94.38.94,1.11v3.14h.67v-3.28c0-1.04-.53-1.58-1.47-1.58-.74,0-1.21.37-1.39.75h0Z"
              />
              <path
                class="sixCls-10"
                d="M288.7,549.78c-.2.17-.63.36-1.1.36-.95,0-1.44-.45-1.51-1.62h3.03c.03-.31.05-.59.05-.82,0-1.13-.6-1.86-1.73-1.86-1.06,0-2.02.71-2.02,2.43s.74,2.47,2.09,2.47c.68,0,1.18-.19,1.5-.43l-.31-.53h0ZM287.38,546.41c.77,0,1.12.45,1.12,1.27,0,.06,0,.17,0,.27h-2.39c.06-1.15.66-1.54,1.28-1.54h0Z"
              />
              <path
                class="sixCls-10"
                d="M292.81,545.87c-.11-.03-.26-.04-.48-.04-.55,0-.99.26-1.2.6h-.03l-.15-.53h-.52v4.76h.67v-3.55c.23-.43.71-.61,1.17-.61.18,0,.36.02.53.07v-.71h0Z"
              />
              <path
                class="sixCls-10"
                d="M297.01,546.11c-.29-.14-.75-.24-1.36-.24-1.58,0-2.32,1.02-2.32,2.55,0,1.62.83,2.23,1.81,2.23.61,0,1.02-.24,1.16-.38h.03v.44c0,.85-.35,1.27-1.22,1.27-.64,0-1.02-.21-1.25-.45l-.39.54c.19.19.67.51,1.57.51,1.19,0,1.96-.62,1.96-1.87v-4.6h0ZM296.34,546.59v2.99c-.23.3-.63.46-1.01.46-.67,0-1.3-.36-1.3-1.72,0-1.26.61-1.86,1.53-1.86.31,0,.58.05.78.13h0Z"
              />
              <path
                class="sixCls-10"
                d="M301.49,549.78c-.2.17-.63.36-1.1.36-.95,0-1.44-.45-1.51-1.62h3.03c.03-.31.05-.59.05-.82,0-1.13-.6-1.86-1.73-1.86-1.06,0-2.02.71-2.02,2.43s.74,2.47,2.09,2.47c.68,0,1.18-.19,1.5-.43l-.31-.53h0ZM300.17,546.41c.77,0,1.12.45,1.12,1.27,0,.06,0,.17,0,.27h-2.39c.06-1.15.66-1.54,1.28-1.54h0Z"
              />
              <path
                class="sixCls-10"
                d="M306.81,547.39c-.03-1.06-.6-1.58-1.55-1.58-.74,0-1.23.43-1.36.6h-.03l-.14-.5h-.52v4.76h.68v-3.41c.17-.46.62-.85,1.21-.85.67,0,1.02.4,1.02,1.13v3.12h.68v-3.28h0Z"
              />
              <path
                class="sixCls-10"
                d="M307.99,548.36c0,1.72.76,2.39,1.93,2.39.81,0,1.22-.29,1.41-.51l-.42-.47c-.19.22-.49.38-.93.38-.8,0-1.29-.52-1.29-1.87s.52-1.84,1.29-1.84c.46,0,.74.19.94.39l.46-.5c-.18-.2-.6-.5-1.36-.5-1.16,0-2.02.78-2.02,2.53h0Z"
              />
              <path
                class="sixCls-10"
                d="M311.81,552.41c.11.04.31.09.54.09.97,0,1.44-.6,1.74-1.5l1.68-5.09h-.71l-.74,2.34c-.31.98-.41,1.38-.49,1.73h-.03c-.11-.41-.25-.88-.53-1.73l-.77-2.34h-.74l1.72,4.93c-.21.74-.53,1.05-1.13,1.05-.13,0-.32-.03-.45-.08l-.11.6h0Z"
              />
              <path
                class="sixCls-10"
                d="M322.21,549.78c-.2.17-.63.36-1.1.36-.95,0-1.44-.45-1.51-1.62h3.03c.03-.31.05-.59.05-.82,0-1.13-.6-1.86-1.73-1.86-1.06,0-2.02.71-2.02,2.43s.74,2.47,2.09,2.47c.68,0,1.18-.19,1.5-.43l-.31-.53h0ZM320.89,546.41c.77,0,1.12.45,1.12,1.27,0,.06,0,.17,0,.27h-2.39c.06-1.15.66-1.54,1.28-1.54h0Z"
              />
              <polygon
                class="sixCls-10"
                points="326.46 550.67 327.25 550.67 325.71 548.21 327.16 545.91 326.36 545.91 325.35 547.67 325.31 547.67 324.24 545.91 323.45 545.91 324.91 548.19 323.37 550.67 324.16 550.67 325.28 548.73 325.31 548.73 326.46 550.67 326.46 550.67"
              />
              <path
                class="sixCls-10"
                d="M328.37,550.67h.68v-4.76h-.68v4.76h0ZM328.17,544.52c0,.28.22.49.49.49.29,0,.51-.21.51-.49s-.22-.5-.51-.5c-.27,0-.49.21-.49.5h0Z"
              />
              <path
                class="sixCls-10"
                d="M332.03,550.71c.57,0,.88-.11,1.07-.22l-.19-.54c-.12.08-.34.17-.73.17-.42,0-.69-.22-.69-.75v-2.91h1.31v-.55h-1.31v-1.25h-.46l-.21,1.23-.71.13v.44h.71v2.94c0,.9.43,1.31,1.22,1.31h0Z"
              />
            </g>
            <g>
              <path
                class="sixCls-16"
                d="M259.51,539.88c-.84-.22-1.47.46-1.62,1.08-.21.88.35,1.58.98,1.75,1.78.49,2.43-2.35.64-2.83h0ZM258.2,546.73l.35-.43c.18-.19.33-.55.57-.67.14.15.11.18.21.37l.54,1.03c.09.31.47.83.53,1.09.05.19-.33.95-.42,1.17l-2.43,5.76c-.12.29-.42.9-.46,1.15,1.51.1,1.68.06,2.11-.85.3-.63.63-1.34.93-1.98.23-.48,1.76-3.8,1.9-3.95.18.56.29,1.53.42,2.18.07.36.12.7.22,1.05.11.39.25.55.68.6h5.15c-.05-.25-.37-.88-.48-1.14-.21-.46-.26-.64-.89-.66-.95-.03-2.19.08-3.09-.02-.15-.9-.35-3.12-.63-3.8-.22-.53-.45-1.04-.66-1.54-.56-1.33-.86-1.65-.19-1.66h1.33c.13.27,1.25,2.25,1.52,2.35.37.13.73-.17.81-.43.11-.34-.17-.69-.32-.96-.34-.64-1.04-2.15-1.48-2.34-.32-.14-2.03-.07-2.52-.07-1.88,0-2.66-.29-3.76,1.39-.21.31-.79,1.39-1,1.53-.11,0-.11-.05-.09.04-.42.03-1.13.06-1.56,0v-7.04c1.05.07,2.42,0,3.52,0l3.43-.02s.03,0,.04-.01c0-.01.02,0,.03-.02l4.28.02v12.22c1.28.16,1.12-.25,1.69.92.17.34.77,1.45.81,1.74h-2.45c-.05.38-.08,2.43.05,2.63.09.14.51.55.66.71.11.12.56.58.61.69-2.23.09-4.96,0-7.3,0-.65,0-.45.08-.96-.49-.34-.38-.49-.65-.82-.67-.46-.02-.99,0-1.45,0,.06.17,0,.09.12.23l.36.38c.13.14.39.4.47.51-.38.05-1.26.03-1.67.02-.28-.01-.33-.18-.48-.35-.13-.14-.25-.26-.39-.41-.61-.63-.55-.51-.55-1.11.01-2.74-.06-5.54,0-8.26.56-.04,1.31.05,1.82-.02.48-.06.58-.59.89-.86h0Z"
              />
              <polygon
                class="sixCls-10"
                points="234.73 548.23 234.73 562.4 230.18 559.07 228.43 561.45 236.2 567.14 236.2 567.14 236.2 567.14 243.97 561.45 242.23 559.07 237.68 562.4 237.68 548.23 249.65 548.23 249.65 545.28 234.73 545.28 234.73 548.23 234.73 548.23 234.73 548.23"
              />
            </g>
          </g>
          <g>
            <path
              class="sixCls-10"
              d="M615.07,753.82c0-.77-.62-1.4-1.4-1.4s-1.4.62-1.4,1.4v9.3c0,.77.63,1.4,1.4,1.4.01,0,.02,0,.04,0,.01,0,.02,0,.04,0h6.25l4.08,5.69c.21.3.55.46.89.46.22,0,.44-.06.63-.2l3.09-2.17c.5-.35.62-1.03.27-1.53-.35-.5-1.03-.62-1.53-.27l-2.2,1.55-3.77-5.26c-.21-.29-.54-.46-.89-.46h-5.49v-2.9h5.27c.53,0,.96-.43.96-.96s-.43-.96-.96-.96h-5.27v-3.69Z"
            />
            <path
              class="sixCls-10"
              d="M613.67,751.83c1.19,0,2.15-.96,2.15-2.15s-.96-2.15-2.15-2.15-2.15.96-2.15,2.15.96,2.15,2.15,2.15Z"
            />
            <path
              class="sixCls-10"
              d="M616.07,772.34c2.68,0,5.05-1.33,6.49-3.37l-.81-1.14c-1.17,1.92-3.28,3.2-5.68,3.2-3.66,0-6.64-2.98-6.64-6.64,0-2.02.91-3.83,2.34-5.05v-1.62c-2.19,1.42-3.64,3.88-3.64,6.67,0,4.38,3.56,7.95,7.95,7.95Z"
            />
            <path
              class="sixCls-10"
              d="M604.25,777.06c0-2.06-.79-3.01-2.55-3.01h-1.53v6.14h1.53c1.79,0,2.56-1.13,2.56-3.12ZM600.83,779.56v-4.89h.81c1.24,0,1.93.64,1.93,2.47s-.6,2.43-1.88,2.43h-.85Z"
            />
            <path
              class="sixCls-10"
              d="M606.44,774.04c0-.29-.21-.5-.48-.5-.26,0-.47.21-.47.5s.21.49.47.49c.28,0,.48-.21.48-.49Z"
            />
            <rect
              class="sixCls-10"
              x="605.67"
              y="775.42"
              width=".65"
              height="4.76"
            />
            <path
              class="sixCls-10"
              d="M608.35,776.64c0-.39.27-.71.89-.71.35,0,.72.16.93.38l.42-.47c-.28-.31-.78-.51-1.33-.51-.99,0-1.55.64-1.55,1.32,0,1.61,2.29,1.18,2.29,2.26,0,.4-.31.75-.94.75-.53,0-.96-.23-1.23-.53l-.4.51c.28.31.85.6,1.6.6,1.09,0,1.62-.7,1.62-1.36,0-1.62-2.29-1.19-2.29-2.26Z"
            />
            <path
              class="sixCls-10"
              d="M615.32,780.16v-.5h-.12c-.32,0-.44-.29-.44-.72v-2.15c0-1-.57-1.44-1.54-1.44s-1.37.55-1.53.78l.48.39c.13-.23.42-.58,1.03-.58s.96.23.96,1.01v.52c-1.61-.03-2.59.49-2.59,1.54,0,.65.47,1.27,1.31,1.27.77,0,1.13-.38,1.35-.64h.03c.11.32.38.58.83.58.08,0,.18-.02.23-.05ZM614.16,779.07c-.21.32-.62.65-1.13.65s-.82-.34-.82-.76c0-.72.86-1,1.95-.95v1.07Z"
            />
            <path
              class="sixCls-10"
              d="M618.14,775.38c-.57,0-.96.25-1.1.37h-.03v-2.21h-.64v6.48c.28.15.71.25,1.28.25,1.5,0,2.23-1.07,2.23-2.62,0-1.63-.78-2.28-1.73-2.28ZM617.73,779.67c-.28,0-.55-.05-.73-.13v-3.1c.21-.3.59-.47.95-.47.63,0,1.25.39,1.25,1.78,0,1.29-.59,1.93-1.48,1.93Z"
            />
            <path
              class="sixCls-10"
              d="M622.55,779.56c-.08.04-.21.1-.37.1-.34,0-.48-.18-.48-.6v-5.51h-.64v5.7c0,.62.3,1.01.92,1.01.18,0,.4-.03.57-.11v-.58Z"
            />
            <path
              class="sixCls-10"
              d="M625.09,775.34c-1.01,0-1.93.71-1.93,2.43s.7,2.47,1.99,2.47c.65,0,1.12-.19,1.43-.43l-.29-.53c-.19.17-.6.36-1.05.36-.91,0-1.38-.45-1.43-1.62h2.89c.03-.31.05-.59.05-.82,0-1.13-.58-1.86-1.65-1.86ZM626.09,777.47h-2.28c.06-1.15.63-1.54,1.22-1.54.73,0,1.07.45,1.07,1.27,0,.06,0,.17,0,.27Z"
            />
            <path
              class="sixCls-10"
              d="M630.57,775.5c-.21-.04-.46-.08-.72-.08-1.28,0-2.15.87-2.15,2.59,0,1.56.65,2.27,1.68,2.27.59,0,1.01-.3,1.18-.58h.03l.14.48h.48v-6.64h-.64v1.96ZM630.57,778.92c-.17.45-.52.77-1.06.77-.6,0-1.16-.43-1.16-1.76s.53-1.92,1.53-1.92c.21,0,.52.05.69.11v2.79Z"
            />
            <path
              class="sixCls-10"
              d="M604.32,788.54c-.13.5-.24,1.02-.35,1.54h-.03c-.09-.48-.19-.91-.29-1.35l-.67-2.81h-.83l-.68,2.81c-.11.44-.2.88-.29,1.35h-.03c-.1-.53-.22-1.02-.34-1.53l-.63-2.63h-.67l1.2,4.76h.88l.97-4.06h.03l.93,4.06h.88l1.22-4.76h-.63l-.64,2.62Z"
            />
            <path
              class="sixCls-10"
              d="M609.3,789.45v-2.15c0-1-.58-1.44-1.54-1.44s-1.37.55-1.53.78l.47.39c.13-.23.43-.58,1.03-.58s.96.23.96,1.01v.52c-1.61-.03-2.59.49-2.59,1.54,0,.65.47,1.27,1.31,1.27.77,0,1.13-.38,1.35-.64h.03c.11.32.37.58.82.58.08,0,.18-.02.23-.05v-.5h-.12c-.32,0-.44-.29-.44-.72ZM608.7,789.57c-.21.32-.62.65-1.13.65s-.82-.34-.82-.76c0-.72.86-1,1.95-.95v1.07Z"
            />
            <path
              class="sixCls-10"
              d="M611.39,787.15c0-.39.28-.71.89-.71.35,0,.72.16.93.38l.42-.47c-.27-.31-.78-.51-1.33-.51-.99,0-1.55.64-1.55,1.32,0,1.61,2.29,1.18,2.29,2.26,0,.4-.31.75-.94.75-.53,0-.96-.23-1.23-.53l-.4.51c.28.31.85.6,1.6.6,1.09,0,1.62-.7,1.62-1.36,0-1.62-2.29-1.19-2.29-2.26Z"
            />
            <path
              class="sixCls-10"
              d="M616.85,785.84c-.77,0-1.18.44-1.31.6h-.03v-2.41h-.65v6.64h.65v-3.4c.16-.41.58-.84,1.21-.84s.92.46.92,1.05v3.19h.65v-3.29c0-.97-.56-1.55-1.44-1.55Z"
            />
            <path
              class="sixCls-10"
              d="M620.31,786.45h-.03l-.14-.53h-.49v4.76h.64v-3.54c.22-.43.67-.61,1.12-.61.17,0,.34.02.51.07v-.71c-.1-.03-.25-.04-.46-.04-.53,0-.94.26-1.14.6Z"
            />
            <path
              class="sixCls-10"
              d="M624.31,785.83c-1.38,0-1.9,1.01-1.9,2.48s.48,2.45,1.85,2.45,1.91-1.02,1.91-2.49-.48-2.43-1.86-2.43ZM624.31,790.17c-.87,0-1.23-.63-1.23-1.91s.33-1.84,1.18-1.84,1.24.62,1.24,1.9-.32,1.85-1.19,1.85Z"
            />
            <path
              class="sixCls-10"
              d="M628.98,785.83c-1.38,0-1.9,1.01-1.9,2.48s.48,2.45,1.85,2.45,1.91-1.02,1.91-2.49-.47-2.43-1.86-2.43ZM628.98,790.17c-.87,0-1.23-.63-1.23-1.91s.33-1.84,1.18-1.84,1.24.62,1.24,1.9-.32,1.85-1.19,1.85Z"
            />
            <path
              class="sixCls-10"
              d="M636.38,785.83c-.71,0-1.15.37-1.33.75h-.03c-.17-.43-.53-.75-1.2-.75-.71,0-1.05.4-1.18.6h-.03l-.13-.51h-.5v4.76h.65v-3.4c.09-.41.46-.85,1.02-.85s.9.41.9,1.16v3.09h.65v-3.46c.12-.38.48-.8,1.04-.8s.89.38.89,1.11v3.14h.64v-3.28c0-1.04-.5-1.58-1.4-1.58Z"
            />
          </g>
          <g>
            <g>
              <g>
                <path
                  class="sixCls-10"
                  d="M569.2,781.13c-.1-.1-.26-.1-.36,0l-.76.76v-2.87c0-.14-.12-.25-.26-.25s-.26.11-.26.25v2.87l-.75-.76c-.1-.1-.26-.1-.36,0-.1.1-.1.26,0,.36l1.16,1.16s.06.05.1.06c.03.01.07.02.11.02s.07,0,.11-.02c.04-.01.07-.03.1-.06l1.16-1.16c.1-.1.1-.26,0-.36h0Z"
                />
                <path
                  class="sixCls-10"
                  d="M569.2,775.24l-1.16-1.16s-.07-.05-.1-.06c-.03-.02-.07-.02-.11-.02s-.08,0-.11.02c-.04.01-.07.03-.1.06l-1.16,1.16c-.1.1-.1.26,0,.36.05.05.12.08.18.08s.13-.02.18-.08l.75-.76v2.87c0,.14.11.26.26.26s.26-.11.26-.26v-2.87l.76.76c.05.05.11.08.18.08s.13-.02.18-.08c.1-.1.1-.26,0-.36h0Z"
                />
                <path
                  class="sixCls-10"
                  d="M546.96,766.89c-.38,0-.7.31-.7.7v21.55c0,.38.31.7.7.7h16.2c.38,0,.7-.31.7-.7v-21.55c0-.38-.31-.7-.7-.7h-16.2ZM563.16,790.77h-16.2c-.9,0-1.63-.73-1.63-1.63v-21.55c0-.9.73-1.63,1.63-1.63h16.2c.9,0,1.63.73,1.63,1.63v21.55c0,.9-.73,1.63-1.63,1.63h0Z"
                />
                <path
                  class="sixCls-10"
                  d="M556.85,771.37c0,.99-.8,1.79-1.79,1.79s-1.79-.8-1.79-1.79.8-1.79,1.79-1.79,1.79.8,1.79,1.79h0Z"
                />
                <path
                  class="sixCls-10"
                  d="M557.23,773.66h-4.34c-.74,0-1.34.51-1.34,1.14v5.36c0,.34.32.61.72.61s.72-.27.72-.61v-5.28h.37v14.09c0,.34.32.61.72.61s.72-.27.72-.61v-7.76h.5v7.76c0,.34.32.61.72.61s.72-.27.72-.61v-14.09h.37v5.28c0,.34.32.61.72.61s.72-.27.72-.61v-5.36c0-.63-.6-1.14-1.34-1.14h0Z"
                />
              </g>
              <g>
                <path
                  class="sixCls-10"
                  d="M596.01,781.14c-.1-.1-.26-.1-.36,0l-.76.76v-2.87c0-.14-.12-.25-.26-.25s-.26.11-.26.25v2.87l-.75-.76c-.1-.1-.26-.1-.36,0-.1.1-.1.26,0,.36l1.16,1.16s.06.05.1.06c.03.01.07.02.11.02s.07,0,.11-.02c.04-.01.07-.03.1-.06l1.16-1.16c.1-.1.1-.26,0-.36h0Z"
                />
                <path
                  class="sixCls-10"
                  d="M596.01,775.25l-1.16-1.16s-.07-.05-.1-.06c-.03-.02-.07-.02-.11-.02s-.08,0-.11.02c-.04.01-.07.03-.1.06l-1.16,1.16c-.1.1-.1.26,0,.36.05.05.12.08.18.08s.13-.02.18-.08l.75-.76v2.87c0,.14.11.26.26.26s.26-.11.26-.26v-2.87l.76.76c.05.05.11.08.18.08s.13-.02.18-.08c.1-.1.1-.26,0-.36h0Z"
                />
                <path
                  class="sixCls-10"
                  d="M573.77,766.9c-.38,0-.7.31-.7.7v21.55c0,.38.31.7.7.7h16.2c.38,0,.7-.31.7-.7v-21.55c0-.38-.31-.7-.7-.7h-16.2ZM589.97,790.78h-16.2c-.9,0-1.63-.73-1.63-1.63v-21.55c0-.9.73-1.63,1.63-1.63h16.2c.9,0,1.63.73,1.63,1.63v21.55c0,.9-.73,1.63-1.63,1.63h0Z"
                />
                <path
                  class="sixCls-10"
                  d="M583.66,771.38c0,.99-.8,1.79-1.79,1.79s-1.79-.8-1.79-1.79.8-1.79,1.79-1.79,1.79.8,1.79,1.79h0Z"
                />
                <path
                  class="sixCls-10"
                  d="M584.04,773.67h-4.34c-.74,0-1.34.51-1.34,1.14v5.36c0,.34.32.61.72.61s.72-.27.72-.61v-5.28h.37v14.09c0,.34.32.61.72.61s.72-.27.72-.61v-7.76h.5v7.76c0,.34.32.61.72.61s.72-.27.72-.61v-14.09h.37v5.28c0,.34.32.61.72.61s.72-.27.72-.61v-5.36c0-.63-.6-1.14-1.34-1.14h0Z"
                />
              </g>
            </g>
            <g>
              <polygon
                class="sixCls-10"
                points="562.23 755.48 562.23 761.62 565.57 761.62 565.57 761 562.93 761 562.93 755.48 562.23 755.48 562.23 755.48"
              />
              <path
                class="sixCls-10"
                d="M566.66,761.62h.68v-4.76h-.68v4.76h0ZM566.47,755.48c0,.28.22.49.49.49.29,0,.51-.21.51-.49s-.22-.5-.51-.5c-.27,0-.49.21-.49.5h0Z"
              />
              <path
                class="sixCls-10"
                d="M571.37,755c-.18-.06-.4-.11-.74-.11-.93,0-1.36.51-1.36,1.24v.72h-.8v.53h.79v4.23h.68v-4.23h1.24v-.53h-1.23v-.73c0-.43.17-.64.63-.64.27,0,.46.03.64.09l.14-.58h0Z"
              />
              <path
                class="sixCls-10"
                d="M573.47,761.66c.57,0,.88-.11,1.07-.22l-.19-.54c-.12.08-.34.17-.73.17-.42,0-.69-.22-.69-.75v-2.91h1.31v-.55h-1.31v-1.25h-.46l-.21,1.23-.71.13v.44h.71v2.94c0,.9.43,1.31,1.22,1.31h0Z"
              />
            </g>
          </g>
        </g>
        <g>
          <g>
            <g>
              <polygon
                class="sixCls-11"
                points="517.98 736.77 516.84 740.71 461.7 742.18 461.7 693.07 539.3 693.07 539.3 733.32 517.98 736.77"
              />
              <polygon
                class="sixCls-11"
                points="539.08 788.87 461.26 788.87 461.26 743.13 515.14 744.09 516.68 745.59 529.36 745.05 530.92 744.37 539.08 744.51 539.08 788.87"
              />
            </g>
            <g>
              <g>
                <path
                  class="sixCls-10"
                  d="M476.74,707.67c0,1.24-1.01,2.25-2.25,2.25s-2.25-1.01-2.25-2.25,1.01-2.25,2.25-2.25,2.25,1.01,2.25,2.25h0Z"
                />
                <path
                  class="sixCls-10"
                  d="M480.44,718.56l-1.55-6.68c-.05-.75-.79-1.34-1.68-1.34h-5.45c-.9,0-1.63.59-1.68,1.34l-1.54,6.68c-.1.42.22.82.72.9.5.08.97-.19,1.07-.61l1.56-6.74s0-.02,0-.04h.32l-1.91,9.9c-.03.16.02.32.15.44.12.12.3.19.49.19h1.43v6.85c0,.42.41.77.91.77s.91-.34.91-.77v-6.85h.63v6.85c0,.42.41.77.91.77s.91-.34.91-.77v-6.85h1.43c.36,0,.65-.25.65-.55,0-.06,0-.11-.03-.16l-1.9-9.83h.32s0,.03,0,.04l1.56,6.74c.08.37.46.62.89.62.06,0,.12,0,.18-.01.49-.08.81-.48.72-.9h0Z"
                />
                <g>
                  <polygon
                    class="sixCls-10"
                    points="487.83 709.71 487.83 715.85 491.16 715.85 491.16 715.23 488.53 715.23 488.53 709.71 487.83 709.71 487.83 709.71"
                  />
                  <path
                    class="sixCls-10"
                    d="M494.49,714.74c-.22.32-.65.65-1.19.65s-.86-.34-.86-.76c0-.72.9-1,2.05-.95v1.07h0ZM493.5,711.02c-.99,0-1.44.55-1.6.78l.5.39c.14-.23.45-.58,1.09-.58s1.01.23,1.01,1.01v.52c-1.69-.03-2.72.49-2.72,1.54,0,.65.49,1.27,1.37,1.27.81,0,1.19-.38,1.42-.64h.03c.11.32.39.58.87.58.09,0,.18-.02.24-.05v-.5h-.12c-.33,0-.46-.29-.46-.72v-2.15c0-1-.6-1.44-1.62-1.44h0Z"
                  />
                  <path
                    class="sixCls-10"
                    d="M499.56,711.17c-.22-.04-.48-.08-.76-.08-1.34,0-2.26.87-2.26,2.59,0,1.56.68,2.27,1.76,2.27.62,0,1.06-.3,1.24-.58h.04l.15.48h.51v-6.64h-.67v1.96h0ZM498.45,715.36c-.63,0-1.22-.43-1.22-1.76s.55-1.92,1.6-1.92c.22,0,.54.05.73.11v2.79c-.18.45-.54.77-1.11.77h0Z"
                  />
                  <path
                    class="sixCls-10"
                    d="M501.92,715.85h.68v-4.76h-.68v4.76h0ZM501.73,709.71c0,.28.22.49.49.49.29,0,.51-.21.51-.49s-.22-.5-.51-.5c-.27,0-.49.21-.49.5h0Z"
                  />
                  <path
                    class="sixCls-10"
                    d="M507.25,714.96c-.2.17-.63.36-1.1.36-.95,0-1.44-.45-1.51-1.62h3.03c.03-.31.05-.59.05-.82,0-1.13-.6-1.86-1.73-1.86-1.06,0-2.02.71-2.02,2.43s.74,2.47,2.09,2.47c.68,0,1.18-.19,1.5-.43l-.31-.53h0ZM505.93,711.6c.77,0,1.12.45,1.12,1.27,0,.06,0,.17,0,.27h-2.39c.06-1.15.66-1.54,1.28-1.54h0Z"
                  />
                  <path
                    class="sixCls-10"
                    d="M511.21,714.59c0,.4-.32.75-.99.75-.55,0-1.01-.23-1.3-.53l-.42.51c.3.31.89.6,1.68.6,1.15,0,1.7-.7,1.7-1.36,0-1.62-2.41-1.19-2.41-2.26,0-.38.29-.71.94-.71.37,0,.75.16.97.39l.44-.47c-.29-.31-.82-.51-1.39-.51-1.04,0-1.63.64-1.63,1.32,0,1.61,2.41,1.18,2.41,2.26h0Z"
                  />
                  <path
                    class="sixCls-10"
                    d="M490.35,722.29l.97,4.06h.92l1.28-4.76h-.66l-.67,2.62c-.13.5-.25,1.02-.37,1.54h-.04c-.1-.48-.2-.91-.31-1.35l-.7-2.81h-.88l-.72,2.81c-.11.44-.21.88-.31,1.35h-.04c-.11-.53-.23-1.02-.36-1.53l-.67-2.63h-.7l1.26,4.76h.92l1.01-4.06h.04Z"
                  />
                  <path
                    class="sixCls-10"
                    d="M496.79,725.24c-.22.32-.65.65-1.19.65s-.86-.34-.86-.76c0-.72.9-1,2.05-.95v1.07h0ZM495.8,721.52c-.99,0-1.44.55-1.6.78l.5.39c.14-.23.45-.58,1.09-.58s1.01.23,1.01,1.01v.52c-1.69-.03-2.72.49-2.72,1.54,0,.65.49,1.27,1.37,1.27.81,0,1.19-.38,1.42-.64h.03c.11.32.39.58.87.58.09,0,.18-.02.24-.05v-.5h-.12c-.33,0-.46-.29-.46-.72v-2.15c0-1-.6-1.44-1.62-1.44h0Z"
                  />
                  <path
                    class="sixCls-10"
                    d="M501.34,725.09c0,.4-.32.75-.99.75-.55,0-1.01-.23-1.3-.53l-.42.51c.3.31.89.6,1.68.6,1.15,0,1.7-.7,1.7-1.36,0-1.62-2.41-1.19-2.41-2.26,0-.38.29-.71.94-.71.37,0,.75.16.97.39l.44-.47c-.29-.31-.82-.51-1.39-.51-1.04,0-1.63.64-1.63,1.32,0,1.61,2.41,1.18,2.41,2.26h0Z"
                  />
                  <path
                    class="sixCls-10"
                    d="M505.34,721.51c-.81,0-1.23.44-1.37.6h-.03v-2.41h-.68v6.64h.68v-3.4c.17-.41.61-.84,1.27-.84s.96.45.96,1.05v3.19h.68v-3.29c0-.97-.59-1.55-1.51-1.55h0Z"
                  />
                  <path
                    class="sixCls-10"
                    d="M510.65,721.56c-.11-.03-.26-.04-.48-.04-.55,0-.99.26-1.2.6h-.03l-.15-.53h-.52v4.76h.67v-3.55c.23-.43.71-.61,1.17-.61.18,0,.36.02.53.07v-.71h0Z"
                  />
                  <path
                    class="sixCls-10"
                    d="M511.88,723.93c0-1.23.34-1.84,1.24-1.84s1.3.62,1.3,1.9-.33,1.85-1.25,1.85-1.3-.63-1.3-1.91h0ZM513.12,726.43c1.44,0,2-1.02,2-2.49s-.5-2.43-1.95-2.43-2,1.01-2,2.48.5,2.45,1.94,2.45h0Z"
                  />
                  <path
                    class="sixCls-10"
                    d="M516.77,723.93c0-1.23.34-1.84,1.24-1.84s1.3.62,1.3,1.9-.33,1.85-1.25,1.85-1.3-.63-1.3-1.91h0ZM518.02,726.43c1.44,0,2-1.02,2-2.49s-.5-2.43-1.95-2.43-2,1.01-2,2.48.5,2.45,1.94,2.45h0Z"
                  />
                  <path
                    class="sixCls-10"
                    d="M524.45,722.25h-.04c-.17-.43-.55-.75-1.26-.75-.74,0-1.1.4-1.23.6h-.03l-.14-.51h-.53v4.76h.68v-3.41c.1-.41.48-.85,1.08-.85s.95.41.95,1.16v3.09h.68v-3.46c.12-.39.5-.8,1.09-.8s.94.38.94,1.11v3.14h.67v-3.28c0-1.04-.53-1.58-1.47-1.58-.74,0-1.21.37-1.39.75h0Z"
                  />
                </g>
              </g>
              <g>
                <path
                  class="sixCls-10"
                  d="M476.71,756.11c0,1.23-1,2.22-2.22,2.22s-2.22-1-2.22-2.22,1-2.22,2.22-2.22,2.22,1,2.22,2.22h0Z"
                />
                <path
                  class="sixCls-10"
                  d="M477.18,758.95h-5.39c-.92,0-1.67.63-1.67,1.41v6.65c0,.42.4.76.9.76s.9-.34.9-.76v-6.55h.46v17.47c0,.42.4.76.9.76s.9-.34.9-.76v-9.63h.62v9.63c0,.42.4.76.9.76s.9-.34.9-.76v-17.47h.46v6.55c0,.42.4.76.9.76s.9-.34.9-.76v-6.65c0-.78-.75-1.41-1.67-1.41h0Z"
                />
                <g>
                  <path
                    class="sixCls-10"
                    d="M490.17,758.09c-1.46,0-2.63.96-2.63,3.18,0,2.09.84,3.13,2.42,3.13.95,0,1.53-.23,1.93-.55v-2.65h-.7v2.35c-.25.17-.68.24-1.08.24-1.2,0-1.86-.74-1.86-2.58,0-2,.98-2.48,1.87-2.48.61,0,1.02.17,1.28.42l.46-.53c-.2-.19-.67-.53-1.69-.53h0Z"
                  />
                  <path
                    class="sixCls-10"
                    d="M496.33,763.42c-.2.17-.63.36-1.1.36-.95,0-1.44-.45-1.51-1.62h3.03c.03-.31.05-.59.05-.82,0-1.13-.6-1.86-1.73-1.86-1.06,0-2.02.71-2.02,2.43s.74,2.47,2.09,2.47c.68,0,1.18-.19,1.5-.43l-.31-.53h0ZM495,760.06c.77,0,1.12.45,1.12,1.27,0,.06,0,.17,0,.27h-2.39c.06-1.15.66-1.54,1.28-1.54h0Z"
                  />
                  <path
                    class="sixCls-10"
                    d="M501.65,761.03c-.03-1.06-.6-1.58-1.55-1.58-.74,0-1.23.43-1.36.6h-.03l-.14-.5h-.52v4.76h.68v-3.41c.17-.46.62-.85,1.21-.85.67,0,1.02.4,1.02,1.13v3.12h.68v-3.28h0Z"
                  />
                  <path
                    class="sixCls-10"
                    d="M504.44,764.36c.57,0,.88-.11,1.07-.22l-.19-.54c-.12.08-.34.17-.73.17-.42,0-.69-.22-.69-.75v-2.91h1.31v-.55h-1.31v-1.25h-.46l-.21,1.23-.71.13v.44h.71v2.94c0,.9.43,1.31,1.22,1.31h0Z"
                  />
                  <path
                    class="sixCls-10"
                    d="M508.65,763.06c0,.4-.32.75-.99.75-.55,0-1.01-.23-1.3-.53l-.42.51c.3.31.89.6,1.68.6,1.15,0,1.7-.7,1.7-1.36,0-1.62-2.41-1.19-2.41-2.26,0-.38.29-.71.94-.71.37,0,.75.16.97.39l.44-.47c-.29-.31-.82-.51-1.39-.51-1.04,0-1.63.64-1.63,1.32,0,1.61,2.41,1.18,2.41,2.26h0Z"
                  />
                  <path
                    class="sixCls-10"
                    d="M490.35,770.76l.97,4.06h.92l1.28-4.76h-.66l-.67,2.62c-.13.5-.25,1.02-.37,1.54h-.04c-.1-.48-.2-.91-.31-1.35l-.7-2.81h-.88l-.72,2.81c-.11.44-.21.88-.31,1.35h-.04c-.11-.53-.23-1.02-.36-1.53l-.67-2.63h-.7l1.26,4.76h.92l1.01-4.06h.04Z"
                  />
                  <path
                    class="sixCls-10"
                    d="M496.79,773.71c-.22.32-.65.65-1.19.65s-.86-.34-.86-.76c0-.72.9-1,2.05-.95v1.07h0ZM495.8,769.99c-.99,0-1.44.55-1.6.78l.5.39c.14-.23.45-.58,1.09-.58s1.01.23,1.01,1.01v.52c-1.69-.03-2.72.49-2.72,1.54,0,.65.49,1.27,1.37,1.27.81,0,1.19-.38,1.42-.64h.03c.11.32.39.58.87.58.09,0,.18-.02.24-.05v-.5h-.12c-.33,0-.46-.29-.46-.72v-2.15c0-1-.6-1.44-1.62-1.44h0Z"
                  />
                  <path
                    class="sixCls-10"
                    d="M501.34,773.56c0,.4-.32.75-.99.75-.55,0-1.01-.23-1.3-.53l-.42.51c.3.31.89.6,1.68.6,1.15,0,1.7-.7,1.7-1.36,0-1.62-2.41-1.19-2.41-2.26,0-.38.29-.71.94-.71.37,0,.75.16.97.39l.44-.47c-.29-.31-.82-.51-1.39-.51-1.04,0-1.63.64-1.63,1.32,0,1.61,2.41,1.18,2.41,2.26h0Z"
                  />
                  <path
                    class="sixCls-10"
                    d="M505.34,769.98c-.81,0-1.23.44-1.37.6h-.03v-2.41h-.68v6.64h.68v-3.4c.17-.41.61-.84,1.27-.84s.96.45.96,1.05v3.19h.68v-3.29c0-.97-.59-1.55-1.51-1.55h0Z"
                  />
                  <path
                    class="sixCls-10"
                    d="M510.65,770.02c-.11-.03-.26-.04-.48-.04-.55,0-.99.26-1.2.6h-.03l-.15-.53h-.52v4.76h.67v-3.55c.23-.43.71-.61,1.17-.61.18,0,.36.02.53.07v-.71h0Z"
                  />
                  <path
                    class="sixCls-10"
                    d="M511.88,772.4c0-1.23.34-1.84,1.24-1.84s1.3.62,1.3,1.9-.33,1.85-1.25,1.85-1.3-.63-1.3-1.91h0ZM513.12,774.9c1.44,0,2-1.02,2-2.49s-.5-2.43-1.95-2.43-2,1.01-2,2.48.5,2.45,1.94,2.45h0Z"
                  />
                  <path
                    class="sixCls-10"
                    d="M516.77,772.4c0-1.23.34-1.84,1.24-1.84s1.3.62,1.3,1.9-.33,1.85-1.25,1.85-1.3-.63-1.3-1.91h0ZM518.02,774.9c1.44,0,2-1.02,2-2.49s-.5-2.43-1.95-2.43-2,1.01-2,2.48.5,2.45,1.94,2.45h0Z"
                  />
                  <path
                    class="sixCls-10"
                    d="M524.45,770.71h-.04c-.17-.43-.55-.75-1.26-.75-.74,0-1.1.4-1.23.6h-.03l-.14-.51h-.53v4.76h.68v-3.41c.1-.41.48-.85,1.08-.85s.95.41.95,1.16v3.09h.68v-3.46c.12-.39.5-.8,1.09-.8s.94.38.94,1.11v3.14h.67v-3.28c0-1.04-.53-1.58-1.47-1.58-.74,0-1.21.37-1.39.75h0Z"
                  />
                </g>
              </g>
            </g>
          </g>
          <path
            class="sixCls-9"
            d="M515.49,742.8h-53.8v-49.84h77.79v40.95l-21.6.31M516.82,742.99l-7.87-.32-7.87.35-7.87-.24-7.87.29-7.87-.47-7.87.49-8.21-.52.39,6.97-.34,6.74.57,6.74-.72,6.74.63,6.74-.34,6.74.32,6.62,10.94.28,11.11-.29,11.11.19,11.11-.23,11.11.19,11.11-.2,11.44-.28-.43-6.18.48-6.11-.42-4.55.03-6.56.47-5.89-.78-5.56.82-5.13-.68-6.61-1.14-.36-1.32.31-2.64.25-2.64.02-1.32-.52"
          />
        </g>
        <g>
          <polygon
            class="sixCls-11"
            points="693.78 790.57 643.18 790.57 642.57 743.73 599.27 743.58 601.2 579.54 600.92 557.74 599.45 497.78 698.39 497.78 694.77 557.82 695.08 579.64 698.68 656.16 696.18 687.97 698.68 715.69 693.78 790.57"
          />
          <polygon
            class="sixCls-12"
            points="609.14 512.52 611.4 512.52 611.4 510.12 613.8 510.12 613.8 507.86 611.4 507.86 611.4 505.46 609.14 505.46 609.14 507.86 606.74 507.86 606.74 510.12 609.14 510.12 609.14 512.52 609.14 512.52"
          />
          <path
            class="sixCls-6"
            d="M697.55,579.62l1.04,80.7-2.41,27.72,2.5,27.72-2.66,26.85-2.03,49.25-50.96.15.15-13.19-.44-14.22v-8.89l-.67-13.93-4.44-.22-11.33.44-8.67.22-10,.22-8.7.07,1.07-34.16-1.62-35.12,1.08-35.12-.74-58.48M598.45,557.86l-.32-25.13,1.32-34.89,20.55-1.49,21.13,1.51,21-.31,21.01.88,16.34-.39-2.49,38.54.27,21.27"
          />
        </g>
        <g>
          <polygon
            class="sixCls-11"
            points="521.87 521.72 527.92 521.91 533.85 521.66 539.78 521.83 545.7 521.62 551.63 521.96 557.56 521.61 563.25 521.98 563.52 527.77 563.28 533.72 563.68 539.68 563.18 545.64 563.61 551.59 563.38 557.55 563.6 563.59 557.56 563.39 551.63 563.6 545.7 563.46 539.78 563.62 533.85 563.49 527.92 563.63 522.06 563.46 521.66 557.55 522.06 551.59 521.98 545.64 522.22 539.68 521.93 533.72 522.34 527.77 521.87 521.72 521.87 521.72"
          />
          <polygon
            class="sixCls-11"
            points="521.87 521.78 527.92 521.96 533.85 521.71 539.78 521.89 545.7 521.68 551.63 522.01 557.56 521.67 563.25 522.03 563.52 527.82 563.28 533.78 563.68 539.74 563.18 545.69 563.61 551.65 563.38 557.6 563.6 563.65 557.56 563.44 551.63 563.65 545.7 563.51 539.78 563.68 533.85 563.54 527.92 563.68 522.06 563.51 521.66 557.6 522.06 551.65 521.98 545.69 522.22 539.74 521.93 533.78 522.34 527.82 521.87 521.78 521.87 521.78"
          />
          <g>
            <polygon
              class="sixCls-8"
              points="521.87 521.78 527.92 521.96 533.85 521.71 539.78 521.89 545.7 521.68 551.63 522.01 557.56 521.67 563.25 522.03 563.52 527.82 563.28 533.78 563.68 539.74 563.18 545.69 563.61 551.65 563.38 557.6 563.6 563.65 557.56 563.44 551.63 563.65 545.7 563.51 539.78 563.68 533.85 563.54 527.92 563.68 522.06 563.51 521.66 557.6 522.06 551.65 521.98 545.69 522.22 539.74 521.93 533.78 522.34 527.82 521.87 521.78 521.87 521.78"
            />
            <path
              class="sixCls-13"
              d="M540.15,538.2c0-.3,4.24-4.21,6.47-1.06.47.66,1.57,2.21,1.62,3.55.05,1.26-1.68,1.83-2.18,2.63-1.3,2.11-2.89.88-4.54-.11-1.12-.67-2.64-.2-2.72-2.52-.05-1.38,1.41.07,1.35-2.48h0Z"
            />
            <path
              class="sixCls-13"
              d="M525.68,555.28c7.43-10.85,6.18,6.42-.26,2.82-.76-.42-.19-2.16.26-2.82h0Z"
            />
            <path
              class="sixCls-13"
              d="M534.55,527.89c-1.12-1.87-4.36.02-6.64.9-1.85.72-2.92.17-2.86,1.42.06,1.18-.02,5.42,4.39,5.71,1.41.09,3.68-2.42,6.05-2.71,3.89-.48-.52-4.62-.94-5.32h0Z"
            />
            <path
              class="sixCls-13"
              d="M557.53,524.65c-14.16-2.84,4,17.9,2.68,3.32-.03-.38-2.21-3.22-2.68-3.32h0Z"
            />
            <path
              class="sixCls-13"
              d="M539.4,551.19c-7.02-3.62-.19,12.47,3.64,5.76,1.72-3.03-1.61-4.71-3.64-5.76h0Z"
            />
            <path
              class="sixCls-13"
              d="M552.85,556.61c-6.5,4.49,10.91,6.03,6.79-.5-1.86-2.95-4.91-.8-6.79.5h0Z"
            />
            <path
              class="sixCls-13"
              d="M558.07,544.24c6.59,11.38-8.45,2.81-2.43-1.45.71-.5,2.03.76,2.43,1.45h0Z"
            />
          </g>
        </g>
        <g>
          <polygon
            class="sixCls-15"
            points="424.05 2.39 428.25 3.03 432.18 4.23 435.54 6.49 438.51 9.21 440.48 12.72 442.1 16.47 442.27 20.68 441.97 24.86 440.48 28.64 438.48 32.13 435.45 34.76 432.17 37.09 428.25 38.35 424.05 38.96 419.85 38.32 415.93 37.09 412.56 34.86 409.63 32.11 407.53 28.68 406.05 24.87 405.7 20.68 405.97 16.47 407.55 12.69 409.69 9.29 412.61 6.57 415.94 4.3 419.87 3.13 424.05 2.39 424.05 2.39"
          />
          <g id="Tower">
            <g>
              <polyline
                class="sixCls-4"
                points="995.33 455.98 998.03 594.56 995.46 692.23 997.65 790.5 930.68 789.07 864.61 790.74 744.74 790"
              />
              <polyline
                class="sixCls-4"
                points="441 16.73 484.34 18.05 541.2 16.14 598.06 18.05 654.92 16.14 711.79 18.05 768.65 16.14 825.51 18.05 882.37 16.14 939.23 18.05 996.77 16.42 995.14 56.97 997.05 96.85 995.14 136.72 997.05 176.6 995.14 216.48 997.05 256.35 995.14 296.23 997.05 336.1 995.14 375.98 997.05 415.86 995.14 455.73"
              />
              <polyline
                class="sixCls-4"
                points="369.66 455.73 371.57 415.86 369.66 375.98 371.57 336.1 369.66 296.23 371.57 256.35 369.66 216.48 371.57 176.6 369.66 136.72 371.57 96.85 369.66 56.97 371.29 17.77 406.88 17.13"
              />
            </g>
            <g>
              <g>
                <path
                  class="sixCls-14"
                  d="M429.24,33.01c-.06-.79-.16-1.71-.39-2.54l-.05-.17-.2-.04c-.48-.11-.95-.14-1.46-.16.04-.03.07-.07.1-.11.07-.11.1-.23.1-.38,0-.12,0-.25-.07-.4l-.06-.13-.2-.03s-.02-.01-.02-.02c0-.84-.02-1.85-.03-2.9v-1.31s0-.02,0-.03c.12-.08.21-.19.26-.31.08-.21.09-.4,0-.57l-.07-.14-.2-.02s-.02-.01-.02-.03c-.01-1.48-.02-2.47-.01-3.13,0-.17.01-.38.02-.65,0-.01,0-.02,0-.02.11-.04.21-.09.29-.16.06-.05.12-.11.18-.19.03-.05.12-.2.05-.36l-.04-.09-.1-.04c-.13-.06-.27-.07-.39-.08v-.26c0-.4,0-.83,0-1.29,0-.81-.01-1.72-.01-2.57,0-.01,0-.02.01-.02.1-.04.18-.09.26-.13l.13-.07v-.13c0-.09,0-.18,0-.26,0-.1-.05-.18-.12-.23-.1-.08-.22-.09-.27-.09h0c.02-1.05.05-1.75.12-2.13v-.02c.08-.83.14-1.65.1-2.46,0-.04,0-.09,0-.14-.01-.26-.03-.64-.49-.9-.27-.11-.58-.14-.85-.16-.11,0-.21-.02-.33-.03h-.02c-.65-.05-1.35-.09-2.07-.09-.93,0-1.72.07-2.43.21l-.11.02-.07.07c-.13.13-.13.27-.13.34,0,.06,0,.11.01.15v.04c0,.47.1.94.18,1.39.04.21.08.43.11.64-.07.03-.12.06-.17.1-.23.18-.23.43-.22.59v.28s.26.02.26.02c.05,0,.1,0,.15,0,0,0,.02,0,.02,0,0,0,0,.01,0,.02l-.03.52c-.07,1.2-.12,2.29-.12,3.4,0,0,0,.01-.02.02-.21.1-.36.25-.44.42l-.05.13.06.08c0,.06.01.22.18.32.09.05.18.06.23.06h.04c0,.74.01,2.1.01,3.49,0,.01,0,.02-.02.03-.23.05-.42.15-.55.28-.09.09-.14.19-.15.3l-.02.15c-.01.09.01.17.07.22.09.1.22.11.27.11l.29.02s0,.04,0,.06l-.02.22.14.03v2.76s0,1.03,0,1.03c0,.01,0,.02-.01.02-.1.03-.19.08-.28.14-.1.08-.32.24-.32.48v.47h.28s.06,0,.11,0c0,0,.04,0,.05,0v.25s.17.02.17.02v.81s0,1.58,0,1.58c-.05.31.01.57.19.78,0,.01,0,.02,0,.03,0,.01-.02.01-.02.01-.35.02-.68.04-.98.07h-.03c-.21.02-.37.03-.48.04h-.06c-.19,0-.46.04-.63.18-.11.1-.16.22-.15.35,0,.11,0,.28,0,.46v.02c-.01.47-.02,1.05,0,1.33v.05c-.01.19-.02.5.23.67.06.04.17.1.33.1.02,0,.05,0,.07,0h9.89s-.02-.34-.02-.34ZM420.89,20.88s0,.02,0,.02c0,0,0,0-.02,0h-.04s.04-.03.07-.04h0ZM423.62,8.71c.58,0,1.17.03,1.75.08.1.02.23.03.36.04.14.01.44.04.5.06.06.03.06.22.07.34v.11c0,.1.01.2.02.3.01.17.02.32,0,.43-.07.3-.06.6-.06.89,0,.25.01.49-.03.71-.14.54-.11,1.08-.08,1.61,0,.07,0,.14.01.21,0,0,0,.01,0,.02,0,0,0,0-.02,0l-.28-.04s-.02-.01-.02-.03v-.08c0-.14-.11-.26-.25-.27l-.64-.08s-.09-.01-.14-.02l.3-.28-.59-.05c-.18-.02-.36-.04-.54-.06-.01,0-.02-.01-.02-.03v-.03c0-.14-.11-.26-.25-.28l-.67-.08s0-.02,0-.03l.05-.26-1.07-.12s-.02-.01-.02-.03v-.4s-.13,0-.13,0c-.02-.41-.09-.81-.17-1.25-.08-.43-.17-.87-.17-1.29.69-.07,1.39-.11,2.09-.11ZM426.18,29.43c0,.23,0,.44,0,.63-.01,0-.02,0-.03,0-.76-.04-1.56-.06-2.36-.06h-.25c-.29-.03-.59-.05-.88-.07-.32-.05-.87-.12-.93-.31-.02-.1-.02-.84-.03-1.25,0-.37,0-.63,0-.7v-.43c.13,0,.26.02.39.03.01,0,.02.01.02.03v.28s.25.03.25.03c.19.02.39.04.58.05.01,0,.02.01.02.02v.06c.02.13.13.23.26.24l.59.06s.02.01.02.03c0,.14.12.26.26.27l.58.04s.02,0,.02.02l.02.1c.02.12.12.22.24.23l.46.06s.01.07.02.1v.23s.27.02.27.02c.11,0,.23.02.35.04.02,0,.07.01.11.02l-.07.2.09.02ZM426.15,28.7c-.05,0-.11-.02-.16-.02-.01,0-.02,0-.02-.01-.02-.07-.05-.13-.08-.19l-.07-.12-.55-.07-.02-.1c-.01-.09-.06-.16-.12-.21-.09-.06-.19-.07-.23-.07l-.49-.03v-.02c0-.14-.12-.25-.25-.27l-.61-.06s-.02-.01-.02-.02l-.04-.31h-.25c-.17-.01-.35-.02-.52-.04-.01,0-.02-.01-.02-.03v-.26s-.24-.04-.24-.04c-.14-.02-.3-.04-.45-.06-.02,0-.03-.01-.02-.03,0-.15-.1-.27-.25-.29h-.03s-.02-.02-.02-.03c-.01-1.34-.02-2.76-.02-4.31.02,0,.05.02.07.02l.45.07s.02.01.02.03c0,.05,0,.1.01.16l.04.21.74.02s.04.09.08.14c.07.07.16.1.27.1.01,0,.03,0,.04,0,.04,0,.08,0,.13,0,.02,0,.05,0,.08,0,0,.04.01.1.05.15.09.13.25.14.3.15l.39.04-.27.23.63.05c.15.01.31.03.47.04l-.23.23.6.02c.15,0,.3.02.44.04,0,.08.01.2.14.29.04.03.09.05.13.06,0,.68-.01,2.29-.01,2.29,0,.8,0,1.57-.01,2.24-.01,0-.02,0-.03,0ZM426.07,23.34c-.1-.02-.19-.03-.29-.04-.04-.07-.09-.12-.17-.16-.13-.07-.27-.09-.4-.1l-.22-.02s-.02-.01-.02-.02c-.04-.06-.09-.12-.15-.16-.14-.09-.31-.11-.42-.12l-.19-.02c0-.05,0-.11-.05-.17-.07-.1-.18-.14-.27-.15-.05-.01-.11-.02-.17-.02-.05,0-.1,0-.14,0-.01,0-.02,0-.03,0v-.23s-.77-.02-.77-.02c0-.01,0-.03.01-.04l.09-.27-.82-.13h0s0-.14-.09-.23c-.08-.07-.17-.09-.21-.09l-.11-.02c0-1.24,0-2.59.02-4.11,0-.02.01-.02.03-.02h.06s.02.02.02.03v.12c.03.13.12.23.25.25l.73.11s.02.01.02.03v.02c0,.14.11.25.24.27l.7.1v.25s.81.12.81.12c0,0,.02.01.02.03.03.09.1.16.19.2.08.04.16.05.21.05l.44.05s.03.08.04.11l.06.13.16.03c.16.02.32.04.48.06l.08.09.02,1.32c-.01.61-.02,1.5-.03,2.8-.05-.01-.09-.03-.15-.03ZM425.36,13.85c.09.08.21.1.26.1l.38.05.02.09c.01.09.05.17.13.22.01,0,.02.01.03.02l.05,4.29s0,.02,0,.02c0,0,0,0-.02,0-.08,0-.16-.02-.25-.03,0-.01,0-.03,0-.04l-.02-.21-.77-.08.07-.21-.9-.13v-.25s-.94-.13-.94-.13c-.01,0-.02-.01-.02-.04,0-.14-.1-.25-.24-.27l-.74-.11s-.02-.01-.02-.02v-.13c-.03-.13-.13-.23-.26-.25l-.41-.05s-.02-.01-.02-.03v-.22c-.01-1.15.06-2.33.13-3.47.01-.23.03-.45.04-.67,0-.01.01-.02.03-.02l.6.06s.02.1.03.14l.05.16.8.1s.02.01.02.03v.26s.24.04.24.04c.17.03.35.05.52.07l.07.05c.04.07.1.14.18.19.16.1.35.12.48.14l.39.05v.04s0,.15.11.25ZM428.43,32.7s0,0-.02,0c-.87-.06-1.88-.07-2.67-.07-.35,0-.7,0-1.05,0-.34,0-.68,0-1.01,0-.45,0-.82,0-1.15,0-.15,0-.3,0-.45,0-.81,0-1.78.02-2.58.05,0-.02,0-.03,0-.04,0-.05,0-.1,0-.14-.03-.25-.05-.85-.06-1.7.03,0,.06,0,.11,0l.6-.03c.91-.04,2.01-.07,3.09-.07h.32c.95.07,1.84.1,2.7.11.02,0,.04,0,.07,0,.14,0,.25-.02.37-.07.65.01,1.14.04,1.51.09v.02c.09.55.21,1.23.24,1.83,0,0,0,.01,0,.02Z"
                />
                <polygon
                  class="sixCls-1"
                  points="426.98 2.39 421.13 2.39 415.57 4.2 410.84 7.63 407.4 12.37 405.59 17.93 405.59 23.78 407.4 29.34 410.84 34.07 415.57 37.51 421.13 39.31 426.98 39.31 432.54 37.51 437.27 34.07 440.71 29.34 442.52 23.78 442.52 17.93 440.71 12.37 437.27 7.63 432.54 4.2 426.98 2.39"
                />
              </g>
              <g>
                <polygon
                  class="sixCls-10"
                  points="407.62 56.82 408.79 56.82 408.79 47.63 411.5 47.63 411.5 46.59 404.89 46.59 404.89 47.63 407.62 47.63 407.62 56.82 407.62 56.82"
                />
                <path
                  class="sixCls-10"
                  d="M413.07,52.78c0-2.06.57-3.06,2.07-3.06s2.17,1.04,2.17,3.17-.55,3.08-2.09,3.08-2.16-1.05-2.16-3.18h0ZM415.15,56.95c2.41,0,3.34-1.71,3.34-4.16s-.83-4.06-3.25-4.06-3.33,1.68-3.33,4.13.83,4.09,3.24,4.09h0Z"
                />
                <path
                  class="sixCls-10"
                  d="M424.67,50.05l1.62,6.77h1.53l2.13-7.94h-1.09l-1.12,4.36c-.22.83-.42,1.71-.61,2.57h-.06c-.16-.8-.34-1.52-.51-2.25l-1.17-4.68h-1.46l-1.2,4.68c-.19.73-.35,1.47-.51,2.25h-.06c-.18-.87-.38-1.71-.6-2.55l-1.11-4.38h-1.17l2.1,7.94h1.53l1.69-6.77h.06Z"
                />
                <path
                  class="sixCls-10"
                  d="M436.39,55.33c-.34.29-1.05.6-1.84.6-1.59,0-2.41-.74-2.51-2.7h5.05c.06-.51.09-.98.09-1.37,0-1.88-1.01-3.11-2.89-3.11-1.77,0-3.37,1.18-3.37,4.06s1.23,4.11,3.49,4.11c1.14,0,1.97-.32,2.49-.71l-.51-.87h0ZM434.18,49.73c1.28,0,1.87.76,1.87,2.12,0,.1,0,.28-.01.45h-3.98c.1-1.91,1.09-2.57,2.13-2.57h0Z"
                />
                <path
                  class="sixCls-10"
                  d="M443.23,48.82c-.18-.04-.44-.07-.8-.07-.92,0-1.65.44-2,1.01h-.06l-.25-.88h-.86v7.94h1.12v-5.91c.38-.71,1.18-1.02,1.95-1.02.29,0,.6.03.89.12v-1.18h0Z"
                />
              </g>
            </g>
          </g>
        </g>
      </svg>
    </div>
  );
}

export default SlideSix;
